(() => {
  'use strict';

  window.BM = window.BM || {};
  if (window.BM.bm_3dPreview_loaded) return;
  window.BM.bm_3dPreview_loaded = true;

  const BM_3D_PREVIEW_ROOT_SELECTOR = '.bm_3dPreview_root[data-bm-section-id]';
  const BM_3D_PREVIEW_SELECTION_EVENT = 'bm:peakExplorer:selection-change';
  const BM_3D_PREVIEW_GPX_EVENT = 'bm:peakExplorer:gpx-change';
  const BM_3D_PREVIEW_GPX_MAX_POINTS = 50000;
  const BM_3D_PREVIEW_SELECTION_DEBOUNCE_MS = 450;
  const BM_3D_PREVIEW_TERRAIN_WIDTH = 3;
  const BM_3D_PREVIEW_MIN_TERRAIN_SIDE_HEIGHT_MM = 4;
  const BM_3D_PREVIEW_MIN_BASE_THICKNESS_MM = 5;
  const BM_3D_PREVIEW_SHADOW_GAP_MM = 8;
  const BM_3D_PREVIEW_BASE_MARGIN_MM = 18;
  const BM_3D_PREVIEW_COMPONENT_TOLERANCE_MM = 0.05;
  const BM_3D_PREVIEW_FALLBACK_PRODUCT_WIDTH_MM = 150;
  const BM_3D_PREVIEW_MIN_GRID_EDGE = 32;
  const BM_3D_PREVIEW_COG_BLOCK_SIZE = 65536;
  const BM_3D_PREVIEW_COG_CACHE_BLOCKS = 64;
  const BM_3D_PREVIEW_MAX_CATALOG_TILES = 10000;
  const BM_3D_PREVIEW_MAX_SELECTION_TILES = 16;
  const BM_3D_PREVIEW_TILE_CONCURRENCY = 4;
  const BM_3D_PREVIEW_MAP_TIMEOUT_MS = 30000;
  const BM_3D_PREVIEW_SNOW_TIMEOUT_MS = 8000;
  const BM_3D_PREVIEW_MAP_MIN_EDGE = 128;
  const BM_3D_PREVIEW_MAP_STYLE_BASE_URL =
    'https://tiles.openfreemap.org/styles/';
  const BM_3D_PREVIEW_MEADOW_MAX_ELEVATION_M = 1500;
  const BM_3D_PREVIEW_MEADOW_COLOR_RGB = Object.freeze([174, 186, 134]);
  const BM_3D_PREVIEW_ROCK_COLOR_RGB = Object.freeze([164, 156, 144]);
  const BM_3D_PREVIEW_FRAME_GRAIN_LENGTH_MM = 400;
  const BM_3D_PREVIEW_FRAME_GRAIN_CROSS_MM = 400;
  const BM_3D_PREVIEW_BASE_GRAIN_SIZE_MM = 400;
  const BM_3D_PREVIEW_PAN_SPEED = 0.35;
  const BM_3D_PREVIEW_MAX_PAN_RADIUS_FACTOR = 0.55;
  const BM_3D_PREVIEW_PRINT_LINE_COUNT = 34;
  const BM_3D_PREVIEW_PRINT_LINE_STRENGTH = 0.028;
  const BM_3D_PREVIEW_PRODUCT_FORM_SELECTOR =
    'form[action*="/cart/add"], form.product-form, [data-product-form]';
  const BM_3D_PREVIEW_VARIANT_EVENTS = Object.freeze([
    'productVariantChanged',
    'variant:change',
    'variant:changed',
    'product:variant-change',
    'theme:variant:change'
  ]);
  const BM_3D_PREVIEW_KM_PER_LATITUDE_DEGREE = 110.574;
  const BM_3D_PREVIEW_KM_PER_LONGITUDE_DEGREE = 111.32;
  const BM_3D_PREVIEW_SNOW_LINE_MIN_M = 0;
  const BM_3D_PREVIEW_SNOW_LINE_MAX_M = 9000;
  const BM_3D_PREVIEW_SNOW_LINE_STEP_M = 100;
  const BM_3D_PREVIEW_SNOW_MODES = Object.freeze([
    'off',
    'snow',
    'glaciers'
  ]);
  const BM_3D_PREVIEW_SNOW_SETTINGS_DEBOUNCE_MS = 220;
  const BM_3D_PREVIEW_SNOW_SETTINGS_EVENT =
    'bm:3dPreview:snow-settings-change';
  const BM_3D_PREVIEW_SNOW_SETTINGS_APPLIED_EVENT =
    'bm:3dPreview:snow-settings-applied';

  const bm_3dPreview_controllers = new WeakMap();
  const bm_3dPreview_vendorPromises = new Map();
  const bm_3dPreview_materialsPromises = new Map();
  const bm_3dPreview_modulePromises = new Map();
  const bm_3dPreview_snowOverrides = new Map();
  const bm_3dPreview_snowStates = new Map();

  let bm_3dPreview_applyWoodTexture;
  let bm_3dPreview_bilinearValue;
  let bm_3dPreview_buildModel;
  let bm_3dPreview_applyGpxTrack;
  let bm_3dPreview_createMapTexture;
  let bm_3dPreview_createTerrainGeometry;
  let bm_3dPreview_mercatorY;
  let bm_3dPreview_readTerrain;
  let bm_3dPreview_servicesPromise = null;
  let bm_3dPreview_servicesReady = false;

  const BM_3D_PREVIEW_GPX_DEBUG_PARAM = 'bm_gpx_debug';
  const BM_3D_PREVIEW_TERRAIN_MESH_NAME = 'bm_3dPreview_terrain';
  const BM_3D_PREVIEW_GPX_OBJECT_NAME = 'bm_3dPreview_gpxTrack';

  function bm_3dPreview_gpxDebugEnabled() {
    try {
      if (window.BM?.bm_3dPreview_debugGpx === true) return true;
      if (window.localStorage?.getItem(BM_3D_PREVIEW_GPX_DEBUG_PARAM) === '1') {
        return true;
      }
      return new URLSearchParams(window.location.search).has(
        BM_3D_PREVIEW_GPX_DEBUG_PARAM
      );
    } catch (_bm_3dPreview_debugError) {
      return false;
    }
  }

  function bm_3dPreview_gpxDebugLog(label, payload) {
    if (!bm_3dPreview_gpxDebugEnabled()) return;
    window.console?.log?.(`[bm_3dPreview_viewer] ${label}`, payload);
  }

  function bm_3dPreview_gpxWarningMessage() {
    if (typeof window.BM.bm_3dPreview_createGpxService !== 'function') {
      return (
        'Der GPS-Track kann in der 3D-Vorschau derzeit nicht dargestellt ' +
        'werden. Auf der Auswahlkarte bleibt er sichtbar.'
      );
    }

    const bm_3dPreview_baseMessage =
      'Der GPS-Track liegt außerhalb des aktuellen 3D-Ausschnitts oder ' +
      'enthält keine darstellbaren Punkte.';
    if (!bm_3dPreview_gpxDebugEnabled()) return bm_3dPreview_baseMessage;

    const bm_3dPreview_diagnostics = window.BM.bm_3dPreview_lastGpxDiagnostics;
    if (!bm_3dPreview_diagnostics) {
      return `${bm_3dPreview_baseMessage} [Diagnose: GPX-Modul lieferte keine Daten]`;
    }
    const bm_3dPreview_statistics = bm_3dPreview_diagnostics.statistics || {};
    return (
      `${bm_3dPreview_baseMessage} [Grund: ${bm_3dPreview_diagnostics.reason}` +
      ` | Projektion: ${bm_3dPreview_diagnostics.projectionSource || '–'}` +
      ` | Polygon: ${bm_3dPreview_diagnostics.projectionUsesPolygon}` +
      ` | Punkte: ${bm_3dPreview_statistics.insidePointCount || 0}/${
        bm_3dPreview_statistics.pointCount || 0
      } innerhalb` +
      ` | UV: ${JSON.stringify(bm_3dPreview_diagnostics.uvBounds || null)}]`
    );
  }

  function bm_3dPreview_gpxIsPartiallyOutside() {
    return (
      window.BM.bm_3dPreview_lastGpxDiagnostics?.reason ===
      'partially_outside_selection'
    );
  }

  function bm_3dPreview_gpxPartialWarningMessage() {
    return (
      'Der GPS-Track liegt teilweise außerhalb des ausgewählten ' +
      'Kartenausschnitts. In der 3D-Vorschau wird nur der darin liegende ' +
      'Abschnitt angezeigt.'
    );
  }

  function bm_3dPreview_resolvedSelectionSectionId(controller) {
    return (
      controller.config.selectionSectionId ||
      controller.boundSelectionSectionId ||
      ''
    );
  }

  function bm_3dPreview_selectionSectionMatches(controller, sectionId) {
    const bm_3dPreview_expectedId = bm_3dPreview_resolvedSelectionSectionId(controller);
    if (!bm_3dPreview_expectedId) return true;
    return String(sectionId || '') === bm_3dPreview_expectedId;
  }

  function bm_3dPreview_number(value, fallback, minimum, maximum) {
    const bm_3dPreview_parsed = Number(value);
    if (!Number.isFinite(bm_3dPreview_parsed)) return fallback;
    return Math.min(maximum, Math.max(minimum, bm_3dPreview_parsed));
  }

  function bm_3dPreview_boolean(value) {
    return String(value).toLowerCase() === 'true';
  }

  function bm_3dPreview_color(value, fallback) {
    return /^#[0-9a-f]{6}$/i.test(String(value || '')) ? String(value) : fallback;
  }

  function bm_3dPreview_sceneLengthFromMillimeters(
    sceneWidth,
    printWidthCm,
    physicalLengthMm
  ) {
    const bm_3dPreview_productWidthMm =
      Number.isFinite(Number(printWidthCm)) && Number(printWidthCm) > 0
        ? Number(printWidthCm) * 10
        : BM_3D_PREVIEW_FALLBACK_PRODUCT_WIDTH_MM;
    return sceneWidth * (physicalLengthMm / bm_3dPreview_productWidthMm);
  }

  function bm_3dPreview_httpsUrl(value, baseUrl = window.location.href) {
    if (!value) return '';

    try {
      const bm_3dPreview_url = new URL(value, baseUrl);
      const bm_3dPreview_isLoopback =
        bm_3dPreview_url.hostname === 'localhost' ||
        bm_3dPreview_url.hostname === '127.0.0.1' ||
        bm_3dPreview_url.hostname === '[::1]';
      return bm_3dPreview_url.protocol === 'https:' ||
        (bm_3dPreview_url.protocol === 'http:' && bm_3dPreview_isLoopback)
        ? bm_3dPreview_url.href
        : '';
    } catch (_bm_3dPreview_error) {
      return '';
    }
  }

  function bm_3dPreview_readConfig(root) {
    const bm_3dPreview_data = root.dataset;
    const bm_3dPreview_extentMode =
      bm_3dPreview_data.bmExtentMode === 'full_cog' ? 'full_cog' : 'peak_selection';
    const bm_3dPreview_frameSources = new Set([
      'generated',
      'external_glb',
      'component_glb'
    ]);
    const bm_3dPreview_frameSource = bm_3dPreview_frameSources.has(
      bm_3dPreview_data.bmFrameSource
    )
      ? bm_3dPreview_data.bmFrameSource
      : 'generated';
    const bm_3dPreview_mapStyles = new Set([
      'bm_custom',
      'liberty',
      'bright',
      'positron',
      'fiord'
    ]);
    const bm_3dPreview_mapStyle = bm_3dPreview_mapStyles.has(
      bm_3dPreview_data.bmMapStyle
    )
      ? bm_3dPreview_data.bmMapStyle
      : 'bm_custom';
    const bm_3dPreview_customMapStyleUrl = bm_3dPreview_httpsUrl(
      bm_3dPreview_data.bmCustomMapStyleUrl
    );

    return Object.freeze({
      sectionId: bm_3dPreview_data.bmSectionId || '',
      vendorUrl: bm_3dPreview_httpsUrl(bm_3dPreview_data.bmVendorUrl),
      terrainModuleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmTerrainModuleUrl
      ),
      mapModuleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmMapModuleUrl
      ),
      modelModuleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmModelModuleUrl
      ),
      gpxModuleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmGpxModuleUrl
      ),
      terrainCatalogUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmTerrainCatalogUrl
      ),
      extentMode: bm_3dPreview_extentMode,
      selectionSectionId: String(bm_3dPreview_data.bmSelectionSectionId || '').trim(),
      autoReloadSelection: bm_3dPreview_boolean(bm_3dPreview_data.bmAutoReloadSelection),
      allowFullFile: bm_3dPreview_boolean(bm_3dPreview_data.bmAllowFullFile),
      elevationBand: Math.round(
        bm_3dPreview_number(bm_3dPreview_data.bmElevationBand, 1, 1, 4)
      ),
      gridResolution: Math.round(
        bm_3dPreview_number(bm_3dPreview_data.bmGridResolution, 160, 64, 256)
      ),
      maxNoDataPercent: bm_3dPreview_number(
        bm_3dPreview_data.bmMaxNodataPercent,
        5,
        0,
        20
      ),
      heightExaggeration: bm_3dPreview_number(
        bm_3dPreview_data.bmHeightExaggeration,
        1.5,
        0.5,
        5
      ),
      frameSource: bm_3dPreview_frameSource,
      frameUrl: bm_3dPreview_httpsUrl(bm_3dPreview_data.bmFrameUrl),
      framePieceUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmFramePieceUrl
      ),
      baseModelUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmBaseModelUrl
      ),
      oakTextureUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmOakTextureUrl
      ),
      walnutTextureUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmWalnutTextureUrl
      ),
      materialOptionName: String(
        bm_3dPreview_data.bmMaterialOptionName || 'Rahmen'
      ).trim(),
      oakVariantValue: String(
        bm_3dPreview_data.bmOakVariantValue || 'Eiche'
      ).trim(),
      walnutVariantValue: String(
        bm_3dPreview_data.bmWalnutVariantValue || 'Nussbaum'
      ).trim(),
      colorOptionName: String(
        bm_3dPreview_data.bmColorOptionName || 'Farbe'
      ).trim(),
      materialsUrl: bm_3dPreview_httpsUrl(bm_3dPreview_data.bmMaterialsUrl),
      frameWidthPercent: bm_3dPreview_number(
        bm_3dPreview_data.bmFrameWidthPercent,
        8,
        4,
        18
      ),
      terrainColor: bm_3dPreview_color(bm_3dPreview_data.bmTerrainColor, '#b8b09b'),
      printTextureUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmPrintTextureUrl
      ),
      printTextureMode:
        bm_3dPreview_data.bmPrintTextureMode === 'color_overlay'
          ? 'color_overlay'
          : 'normal_map',
      printTextureStrength:
        bm_3dPreview_number(
          bm_3dPreview_data.bmPrintTextureStrength,
          35,
          0,
          100
        ) / 100,
      printTextureNormalStrength:
        bm_3dPreview_number(
          bm_3dPreview_data.bmPrintTextureNormalStrength,
          60,
          0,
          200
        ) / 100,
      printTextureScaleMm: bm_3dPreview_number(
        bm_3dPreview_data.bmPrintTextureScaleMm,
        200,
        5,
        500
      ),
      mapTextureEnabled: bm_3dPreview_boolean(
        bm_3dPreview_data.bmMapTextureEnabled
      ),
      mapStyleUrl:
        bm_3dPreview_mapStyle === 'bm_custom' &&
        bm_3dPreview_customMapStyleUrl
          ? bm_3dPreview_customMapStyleUrl
          : `${BM_3D_PREVIEW_MAP_STYLE_BASE_URL}${
              bm_3dPreview_mapStyle === 'bm_custom'
                ? 'liberty'
                : bm_3dPreview_mapStyle
            }`,
      bmCustomMapStyleUrl: bm_3dPreview_customMapStyleUrl,
      topographicMapStyleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmTopographicMapStyleUrl
      ),
      satelliteMapStyleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmSatelliteMapStyleUrl
      ),
      mapTextureResolution: Math.round(
        bm_3dPreview_number(
          bm_3dPreview_data.bmMapTextureResolution,
          1024,
          256,
          2048
        )
      ),
      snowWorkerUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmSnowWorkerUrl
      ),
      snowEnabled: bm_3dPreview_boolean(bm_3dPreview_data.bmSnowEnabled),
      snowBaseLineM: bm_3dPreview_number(
        bm_3dPreview_data.bmSnowBaseLineM,
        2400,
        BM_3D_PREVIEW_SNOW_LINE_MIN_M,
        BM_3D_PREVIEW_SNOW_LINE_MAX_M
      ),
      snowNorthLoweringM: bm_3dPreview_number(
        bm_3dPreview_data.bmSnowNorthLoweringM,
        150,
        0,
        300
      ),
      snowSouthRaisingM: bm_3dPreview_number(
        bm_3dPreview_data.bmSnowSouthRaisingM,
        150,
        0,
        300
      ),
      snowSlopeOffsetM: bm_3dPreview_number(
        bm_3dPreview_data.bmSnowSlopeOffsetM,
        250,
        0,
        500
      ),
      snowTpiEnabled: bm_3dPreview_boolean(
        bm_3dPreview_data.bmSnowTpiEnabled
      ),
      snowSmoothingRadiusPx: Math.round(
        bm_3dPreview_number(
          bm_3dPreview_data.bmSnowSmoothingRadiusPx,
          1,
          0,
          2
        )
      ),
      snowResolution: Math.round(
        bm_3dPreview_number(
          bm_3dPreview_data.bmSnowResolution,
          512,
          256,
          512
        )
      ),
      waterMapStyleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmWaterMapStyleUrl
      ),
      glacierMapStyleUrl: bm_3dPreview_httpsUrl(
        bm_3dPreview_data.bmGlacierMapStyleUrl
      ),
      mapLibreUrl: bm_3dPreview_httpsUrl(bm_3dPreview_data.bmMaplibreUrl),
      frameColor: bm_3dPreview_color(bm_3dPreview_data.bmFrameColor, '#8a5a35'),
      baseColor: bm_3dPreview_color(bm_3dPreview_data.bmBaseColor, '#ded8cb'),
      backgroundColor: bm_3dPreview_color(
        bm_3dPreview_data.bmBackgroundColor,
        '#253545'
      ),
      designMode: bm_3dPreview_boolean(bm_3dPreview_data.bmDesignMode)
    });
  }

  function bm_3dPreview_normalizedLabel(value) {
    return String(value || '')
      .normalize('NFKC')
      .trim()
      .toLocaleLowerCase('de-DE');
  }

  function bm_3dPreview_selectionIsValid(selection) {
    if (!selection || typeof selection !== 'object') return false;
    const bm_3dPreview_center = selection.center;
    const bm_3dPreview_bounds = selection.bounds;
    const bm_3dPreview_widthKm = Number(selection.widthKm);
    const bm_3dPreview_heightKm = Number(selection.heightKm);

    return (
      Array.isArray(bm_3dPreview_center) &&
      bm_3dPreview_center.length === 2 &&
      bm_3dPreview_center.every(Number.isFinite) &&
      Array.isArray(bm_3dPreview_bounds) &&
      bm_3dPreview_bounds.length === 4 &&
      bm_3dPreview_bounds.every(Number.isFinite) &&
      bm_3dPreview_bounds[0] < bm_3dPreview_bounds[2] &&
      bm_3dPreview_bounds[1] < bm_3dPreview_bounds[3] &&
      Number.isFinite(bm_3dPreview_widthKm) &&
      bm_3dPreview_widthKm > 0 &&
      Number.isFinite(bm_3dPreview_heightKm) &&
      bm_3dPreview_heightKm > 0
    );
  }

  function bm_3dPreview_cloneSelection(selection) {
    if (!bm_3dPreview_selectionIsValid(selection)) return null;

    return Object.freeze({
      sectionId: String(selection.sectionId || ''),
      center: Object.freeze([Number(selection.center[0]), Number(selection.center[1])]),
      bounds: Object.freeze(selection.bounds.map(Number)),
      widthKm: Number(selection.widthKm),
      heightKm: Number(selection.heightKm),
      printWidthCm:
        Number.isFinite(Number(selection.printWidthCm)) &&
        Number(selection.printWidthCm) > 0
          ? Number(selection.printWidthCm)
          : null,
      printHeightCm:
        Number.isFinite(Number(selection.printHeightCm)) &&
        Number(selection.printHeightCm) > 0
          ? Number(selection.printHeightCm)
          : null,
      rotationDeg: bm_3dPreview_number(selection.rotationDeg, 0, 0, 180),
      polygon: Array.isArray(selection.polygon)
        ? Object.freeze(
            selection.polygon.map((bm_3dPreview_coordinate) =>
              Object.freeze([
                Number(bm_3dPreview_coordinate[0]),
                Number(bm_3dPreview_coordinate[1])
              ])
            )
          )
        : Object.freeze([])
    });
  }

  function bm_3dPreview_cloneGpxTrack(input) {
    if (!input || typeof input !== 'object' || !Array.isArray(input.segments)) return null;
    const bm_3dPreview_segments = [];
    let bm_3dPreview_pointCount = 0;

    for (const bm_3dPreview_sourceSegment of input.segments) {
      if (!Array.isArray(bm_3dPreview_sourceSegment)) continue;
      const bm_3dPreview_segment = [];
      for (const bm_3dPreview_sourcePoint of bm_3dPreview_sourceSegment) {
        const bm_3dPreview_longitude = Number(bm_3dPreview_sourcePoint?.[0]);
        const bm_3dPreview_latitude = Number(bm_3dPreview_sourcePoint?.[1]);
        if (
          !Number.isFinite(bm_3dPreview_longitude) ||
          bm_3dPreview_longitude < -180 ||
          bm_3dPreview_longitude > 180 ||
          !Number.isFinite(bm_3dPreview_latitude) ||
          bm_3dPreview_latitude < -90 ||
          bm_3dPreview_latitude > 90
        ) {
          return null;
        }

        const bm_3dPreview_elevation = Number(bm_3dPreview_sourcePoint?.[2]);
        bm_3dPreview_segment.push(Object.freeze([
          bm_3dPreview_longitude,
          bm_3dPreview_latitude,
          Number.isFinite(bm_3dPreview_elevation) ? bm_3dPreview_elevation : null
        ]));
        bm_3dPreview_pointCount += 1;
        if (bm_3dPreview_pointCount > BM_3D_PREVIEW_GPX_MAX_POINTS) return null;
      }
      if (bm_3dPreview_segment.length >= 2) {
        bm_3dPreview_segments.push(Object.freeze(bm_3dPreview_segment));
      }
    }
    if (!bm_3dPreview_segments.length) return null;

    return Object.freeze({
      sectionId: String(input.sectionId || ''),
      fileName: String(input.fileName || '').slice(0, 120),
      trackName: String(input.trackName || '').slice(0, 120),
      uploadId: String(input.uploadId || '').slice(0, 80),
      color: String(input.color || '').slice(0, 20),
      pointCount: bm_3dPreview_pointCount,
      segments: Object.freeze(bm_3dPreview_segments),
      selection: bm_3dPreview_cloneSelection(input.selection)
    });
  }

  function bm_3dPreview_terrainHasMapTexture(controller) {
    const bm_3dPreview_mesh = controller.sceneState?.currentModel?.getObjectByName(
      BM_3D_PREVIEW_TERRAIN_MESH_NAME
    );
    const bm_3dPreview_materials = Array.isArray(bm_3dPreview_mesh?.material)
      ? bm_3dPreview_mesh.material
      : [bm_3dPreview_mesh?.material];
    return bm_3dPreview_materials.some(
      (bm_3dPreview_material) =>
        typeof bm_3dPreview_material?.map?.image?.getContext === 'function'
    );
  }

  function bm_3dPreview_removeRedundantGpxGeometry(controller) {
    const bm_3dPreview_model = controller.sceneState?.currentModel;
    if (!bm_3dPreview_model || !bm_3dPreview_terrainHasMapTexture(controller)) return;

    const bm_3dPreview_overlay = bm_3dPreview_model.getObjectByName(
      BM_3D_PREVIEW_GPX_OBJECT_NAME
    );
    if (!bm_3dPreview_overlay) return;

    bm_3dPreview_overlay.parent?.remove(bm_3dPreview_overlay);
    bm_3dPreview_disposeObject(bm_3dPreview_overlay);
    bm_3dPreview_gpxDebugLog('Doppelte GPX-Geometrie entfernt', {
      sectionId: controller.config.sectionId
    });
  }

  function bm_3dPreview_gpxRenderSignature(track) {
    if (!track?.segments?.length) return '';
    const bm_3dPreview_firstSegment = track.segments[0];
    const bm_3dPreview_lastSegment = track.segments[track.segments.length - 1];
    const bm_3dPreview_first = bm_3dPreview_firstSegment[0] || [];
    const bm_3dPreview_last =
      bm_3dPreview_lastSegment[bm_3dPreview_lastSegment.length - 1] || [];
    return [
      track.color,
      track.segments.length,
      track.pointCount,
      bm_3dPreview_first[0],
      bm_3dPreview_first[1],
      bm_3dPreview_last[0],
      bm_3dPreview_last[1]
    ].join('|');
  }

  function bm_3dPreview_sameSelection(first, second) {
    if (!first || !second) return false;
    const values = [
      first.center?.[0],
      first.center?.[1],
      first.widthKm,
      first.heightKm,
      first.rotationDeg,
      second.center?.[0],
      second.center?.[1],
      second.widthKm,
      second.heightKm,
      second.rotationDeg
    ].map(Number);
    if (!values.every(Number.isFinite)) return false;

    return (
      Math.abs(values[0] - values[5]) <= 1e-7 &&
      Math.abs(values[1] - values[6]) <= 1e-7 &&
      Math.abs(values[2] - values[7]) <= 1e-7 &&
      Math.abs(values[3] - values[8]) <= 1e-7 &&
      Math.abs(values[4] - values[9]) <= 1e-7
    );
  }

  function bm_3dPreview_readProductData(root) {
    const bm_3dPreview_element = root.querySelector(
      'script[type="application/json"][data-bm-role="product-data"]'
    );
    if (!bm_3dPreview_element) return null;

    try {
      const bm_3dPreview_data = JSON.parse(
        bm_3dPreview_element.textContent || '{}'
      );
      if (
        !Array.isArray(bm_3dPreview_data.optionNames) ||
        !Array.isArray(bm_3dPreview_data.variants)
      ) {
        return null;
      }
      return bm_3dPreview_data;
    } catch (_bm_3dPreview_error) {
      return null;
    }
  }

  function bm_3dPreview_parseMaterials(rawMaterials) {
    if (
      !rawMaterials ||
      typeof rawMaterials !== 'object' ||
      rawMaterials.schema !== 'bm_3dPreview_materials' ||
      Number(rawMaterials.schema_version) !== 1 ||
      !Array.isArray(rawMaterials.patterns) ||
      rawMaterials.patterns.length === 0 ||
      rawMaterials.patterns.length > 24
    ) {
      throw bm_3dPreview_failure('color', 'Die Farbauswahl ist derzeit nicht verfügbar.');
    }

    const bm_3dPreview_ids = new Set();
    const bm_3dPreview_values = new Set();
    return Object.freeze(
      rawMaterials.patterns.map((bm_3dPreview_pattern) => {
        const bm_3dPreview_id = String(bm_3dPreview_pattern?.id || '').trim();
        const bm_3dPreview_label = String(bm_3dPreview_pattern?.label || '').trim();
        const bm_3dPreview_variantValue = String(
          bm_3dPreview_pattern?.variant_value || ''
        ).trim();
        const bm_3dPreview_mapMode = ['none', 'water', 'osm'].includes(
          bm_3dPreview_pattern?.map_mode
        )
          ? bm_3dPreview_pattern.map_mode
          : '';
        const bm_3dPreview_terrainColor = bm_3dPreview_color(
          bm_3dPreview_pattern?.terrain_color,
          ''
        );
        const bm_3dPreview_swatchColor = bm_3dPreview_color(
          bm_3dPreview_pattern?.swatch_color,
          ''
        );
        const bm_3dPreview_osmFeatureColor = bm_3dPreview_color(
          bm_3dPreview_pattern?.osm_feature_color,
          ''
        );
        const bm_3dPreview_valueKey = bm_3dPreview_normalizedLabel(
          bm_3dPreview_variantValue
        );

        if (
          !/^[a-z][a-z\d_-]{0,63}$/i.test(bm_3dPreview_id) ||
          !bm_3dPreview_label ||
          bm_3dPreview_label.length > 80 ||
          !bm_3dPreview_variantValue ||
          !bm_3dPreview_mapMode ||
          !bm_3dPreview_terrainColor ||
          !bm_3dPreview_swatchColor ||
          (bm_3dPreview_mapMode === 'osm' && !bm_3dPreview_osmFeatureColor) ||
          bm_3dPreview_ids.has(bm_3dPreview_id) ||
          bm_3dPreview_values.has(bm_3dPreview_valueKey)
        ) {
          throw bm_3dPreview_failure('color', 'Die Farbauswahl ist derzeit nicht verfügbar.');
        }

        bm_3dPreview_ids.add(bm_3dPreview_id);
        bm_3dPreview_values.add(bm_3dPreview_valueKey);
        return Object.freeze({
          id: bm_3dPreview_id,
          label: bm_3dPreview_label,
          variantValue: bm_3dPreview_variantValue,
          variantValueKey: bm_3dPreview_valueKey,
          terrainColor: bm_3dPreview_terrainColor,
          swatchColor: bm_3dPreview_swatchColor,
          osmFeatureColor: bm_3dPreview_osmFeatureColor,
          mapMode: bm_3dPreview_mapMode
        });
      })
    );
  }

  async function bm_3dPreview_loadMaterials(controller) {
    const bm_3dPreview_url = controller.config.materialsUrl;
    if (!bm_3dPreview_url) {
      throw bm_3dPreview_failure('color', 'Die Farbauswahl ist derzeit nicht verfügbar.');
    }
    if (!bm_3dPreview_materialsPromises.has(bm_3dPreview_url)) {
      const bm_3dPreview_promise = window
        .fetch(bm_3dPreview_url, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'force-cache'
        })
        .then((bm_3dPreview_response) => {
          if (!bm_3dPreview_response.ok) throw new Error();
          return bm_3dPreview_response.json();
        })
        .then(bm_3dPreview_parseMaterials)
        .catch((bm_3dPreview_error) => {
          bm_3dPreview_materialsPromises.delete(bm_3dPreview_url);
          if (bm_3dPreview_error?.bm_3dPreview_adminKey) throw bm_3dPreview_error;
          throw bm_3dPreview_failure('color', 'Die Farbauswahl ist derzeit nicht verfügbar.');
        });
      bm_3dPreview_materialsPromises.set(bm_3dPreview_url, bm_3dPreview_promise);
    }
    return bm_3dPreview_materialsPromises.get(bm_3dPreview_url);
  }

  function bm_3dPreview_currentColorValue(controller) {
    const bm_3dPreview_variantId = Number(
      bm_3dPreview_findProductForm(controller)?.querySelector('[name="id"]')?.value ||
        controller.productData?.selectedVariantId
    );
    if (
      Number.isFinite(bm_3dPreview_variantId) &&
      controller.colorOptionIndex >= 0
    ) {
      const bm_3dPreview_variant = controller.productData?.variants?.find(
        (bm_3dPreview_item) => Number(bm_3dPreview_item?.id) === bm_3dPreview_variantId
      );
      const bm_3dPreview_value =
        bm_3dPreview_variant?.options?.[controller.colorOptionIndex] ??
        bm_3dPreview_variant?.[`option${controller.colorOptionIndex + 1}`];
      if (bm_3dPreview_value) return String(bm_3dPreview_value);
    }

    const bm_3dPreview_controls = bm_3dPreview_getColorControls(controller);
    const bm_3dPreview_control = bm_3dPreview_controls.find(
      (bm_3dPreview_item) =>
        bm_3dPreview_item.type !== 'radio' || bm_3dPreview_item.checked
    );
    return bm_3dPreview_control ? String(bm_3dPreview_control.value || '') : '';
  }

  function bm_3dPreview_getColorControls(controller) {
    const bm_3dPreview_optionName = bm_3dPreview_normalizedLabel(
      controller.config.colorOptionName
    );
    const bm_3dPreview_form = bm_3dPreview_findProductForm(controller);
    const bm_3dPreview_controls = Array.from(
      document.querySelectorAll('input[name^="options["], select[name^="options["]')
    );
    return bm_3dPreview_controls.filter((bm_3dPreview_control) => {
      const bm_3dPreview_match = String(bm_3dPreview_control.name || '').match(
        /^options\[(.*)]$/
      );
      if (
        !bm_3dPreview_match ||
        bm_3dPreview_normalizedLabel(bm_3dPreview_match[1]) !== bm_3dPreview_optionName
      ) {
        return false;
      }
      return !bm_3dPreview_form || bm_3dPreview_control.form === bm_3dPreview_form ||
        bm_3dPreview_form.contains(bm_3dPreview_control) ||
        !bm_3dPreview_control.form;
    });
  }

  function bm_3dPreview_availableColorValueKeys(controller) {
    const bm_3dPreview_swatchValues = (controller.productData?.colorSwatches || [])
      .map((bm_3dPreview_swatch) =>
        bm_3dPreview_normalizedLabel(bm_3dPreview_swatch?.value)
      )
      .filter(Boolean);
    if (bm_3dPreview_swatchValues.length) {
      return new Set(bm_3dPreview_swatchValues);
    }

    const bm_3dPreview_variantValues = (controller.productData?.variants || [])
      .map((bm_3dPreview_variant) =>
        bm_3dPreview_variant?.options?.[controller.colorOptionIndex] ??
        bm_3dPreview_variant?.[`option${controller.colorOptionIndex + 1}`]
      )
      .map(bm_3dPreview_normalizedLabel)
      .filter(Boolean);
    return new Set(bm_3dPreview_variantValues);
  }

  function bm_3dPreview_filterAvailableMaterials(controller, materials) {
    const bm_3dPreview_availableValues = bm_3dPreview_availableColorValueKeys(controller);
    if (!bm_3dPreview_availableValues.size) return Object.freeze([]);
    return Object.freeze(
      materials.filter((bm_3dPreview_material) =>
        bm_3dPreview_availableValues.has(bm_3dPreview_material.variantValueKey)
      )
    );
  }

  function bm_3dPreview_findThemeSwatchLabel(control) {
    if (!control) return null;
    if (control.closest('label')) return control.closest('label');
    if (!control.id) return null;
    return Array.from(document.querySelectorAll('label[for]')).find(
      (bm_3dPreview_label) => bm_3dPreview_label.htmlFor === control.id
    ) || null;
  }

  function bm_3dPreview_findThemeSwatchElement(controller, variantValue) {
    const bm_3dPreview_valueKey = bm_3dPreview_normalizedLabel(variantValue);
    const bm_3dPreview_scope =
      bm_3dPreview_findProductForm(controller) || document;
    const bm_3dPreview_candidates = bm_3dPreview_scope.querySelectorAll(
      '[data-option-value], [data-value], [data-swatch-value], [data-color-value]'
    );
    return Array.from(bm_3dPreview_candidates).find((bm_3dPreview_element) => {
      const bm_3dPreview_value =
        bm_3dPreview_element.getAttribute('data-option-value') ||
        bm_3dPreview_element.getAttribute('data-value') ||
        bm_3dPreview_element.getAttribute('data-swatch-value') ||
        bm_3dPreview_element.getAttribute('data-color-value') ||
        '';
      return bm_3dPreview_normalizedLabel(bm_3dPreview_value) === bm_3dPreview_valueKey;
    }) || null;
  }

  function bm_3dPreview_productSwatchPresentation(controller, variantValue) {
    const bm_3dPreview_valueKey = bm_3dPreview_normalizedLabel(variantValue);
    const bm_3dPreview_swatch = (controller.productData?.colorSwatches || []).find(
      (bm_3dPreview_item) =>
        bm_3dPreview_normalizedLabel(bm_3dPreview_item?.value) === bm_3dPreview_valueKey
    );
    if (!bm_3dPreview_swatch || typeof bm_3dPreview_swatch !== 'object') return null;

    return Object.freeze({
      label: String(bm_3dPreview_swatch.label || bm_3dPreview_swatch.value || '').trim(),
      imageUrl: bm_3dPreview_httpsUrl(bm_3dPreview_swatch.image),
      swatchColor: bm_3dPreview_color(bm_3dPreview_swatch.color, '')
    });
  }

  function bm_3dPreview_themeSwatchImageUrl(label) {
    if (!label) return '';
    const bm_3dPreview_image = label.querySelector('img[src]');
    if (bm_3dPreview_image) {
      return bm_3dPreview_httpsUrl(
        bm_3dPreview_image.currentSrc || bm_3dPreview_image.getAttribute('src')
      );
    }

    const bm_3dPreview_swatchElement = label.querySelector(
      '[data-swatch-image], [class*="swatch"], [class*="color"]'
    );
    const bm_3dPreview_background = window.getComputedStyle(
      bm_3dPreview_swatchElement || label
    ).backgroundImage;
    const bm_3dPreview_match = String(bm_3dPreview_background || '').match(
      /^url\(["']?(.*?)["']?\)$/
    );
    if (bm_3dPreview_match) {
      return bm_3dPreview_httpsUrl(bm_3dPreview_match[1]);
    }

    const bm_3dPreview_inlineSvg = label.querySelector('svg');
    return bm_3dPreview_inlineSvg
      ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
          bm_3dPreview_inlineSvg.outerHTML
        )}`
      : '';
  }

  function bm_3dPreview_themeSwatchPresentation(controller, material) {
    const bm_3dPreview_valueKey = bm_3dPreview_normalizedLabel(material.variantValue);
    const bm_3dPreview_control = bm_3dPreview_getColorControls(controller).find(
      (bm_3dPreview_item) =>
        bm_3dPreview_normalizedLabel(bm_3dPreview_item.value) === bm_3dPreview_valueKey
    );
    const bm_3dPreview_label = bm_3dPreview_findThemeSwatchLabel(
      bm_3dPreview_control
    );
    const bm_3dPreview_swatchElement =
      bm_3dPreview_label ||
      bm_3dPreview_findThemeSwatchElement(controller, material.variantValue);
    const bm_3dPreview_productSwatch = bm_3dPreview_productSwatchPresentation(
      controller,
      material.variantValue
    );
    return Object.freeze({
      label:
        bm_3dPreview_productSwatch?.label ||
        String(bm_3dPreview_control?.value || material.variantValue).trim() ||
        material.label,
      imageUrl:
        bm_3dPreview_productSwatch?.imageUrl ||
        bm_3dPreview_themeSwatchImageUrl(bm_3dPreview_swatchElement),
      swatchColor: bm_3dPreview_productSwatch?.swatchColor || ''
    });
  }

  function bm_3dPreview_selectedColor(controller) {
    return controller.selectedColor || Object.freeze({
      terrainColor: controller.config.terrainColor,
      osmFeatureColor: '',
      mapMode: controller.config.mapTextureEnabled ? 'osm' : 'none'
    });
  }

  function bm_3dPreview_selectedMapStyleUrl(controller) {
    const bm_3dPreview_colorMaterial = bm_3dPreview_selectedColor(controller);
    if (bm_3dPreview_colorMaterial.mapMode === 'topographic') {
      return controller.config.topographicMapStyleUrl;
    }
    if (bm_3dPreview_colorMaterial.mapMode === 'satellite') {
      return controller.config.satelliteMapStyleUrl;
    }
    if (bm_3dPreview_colorMaterial.mapMode === 'water') {
      return controller.config.waterMapStyleUrl;
    }
    if (
      bm_3dPreview_colorMaterial.mapMode === 'osm' &&
      bm_3dPreview_colorMaterial.osmFeatureColor &&
      controller.config.bmCustomMapStyleUrl
    ) {
      return controller.config.bmCustomMapStyleUrl;
    }
    return controller.config.mapStyleUrl;
  }

  function bm_3dPreview_woodKeyFromValue(controller, value) {
    const bm_3dPreview_value = bm_3dPreview_normalizedLabel(value);
    if (
      bm_3dPreview_value ===
      bm_3dPreview_normalizedLabel(controller.config.oakVariantValue)
    ) {
      return 'oak';
    }
    if (
      bm_3dPreview_value ===
      bm_3dPreview_normalizedLabel(controller.config.walnutVariantValue)
    ) {
      return 'walnut';
    }
    if (bm_3dPreview_value.includes('eiche') || bm_3dPreview_value.includes('oak')) {
      return 'oak';
    }
    if (bm_3dPreview_value.includes('nussbaum') || bm_3dPreview_value.includes('walnut')) {
      return 'walnut';
    }
    return '';
  }

  function bm_3dPreview_findProductForm(controller) {
    const bm_3dPreview_variantIds = controller.productVariantIds;
    const bm_3dPreview_forms = Array.from(
      document.querySelectorAll(BM_3D_PREVIEW_PRODUCT_FORM_SELECTOR)
    );
    return (
      bm_3dPreview_forms.find((bm_3dPreview_form) => {
        if (!bm_3dPreview_variantIds.size) return true;
        const bm_3dPreview_variantId = Number(
          bm_3dPreview_form.querySelector('[name="id"]')?.value
        );
        return (
          Number.isFinite(bm_3dPreview_variantId) &&
          bm_3dPreview_variantIds.has(bm_3dPreview_variantId)
        );
      }) ||
      (!bm_3dPreview_variantIds.size ? bm_3dPreview_forms[0] : null) ||
      null
    );
  }

  function bm_3dPreview_currentWoodKey(controller) {
    const bm_3dPreview_productData = controller.productData;
    const bm_3dPreview_optionIndex = controller.materialOptionIndex;
    const bm_3dPreview_form = bm_3dPreview_findProductForm(controller);
    const bm_3dPreview_variantId = Number(
      bm_3dPreview_form?.querySelector('[name="id"]')?.value ||
        bm_3dPreview_productData?.selectedVariantId
    );

    if (
      bm_3dPreview_productData &&
      bm_3dPreview_optionIndex >= 0 &&
      Number.isFinite(bm_3dPreview_variantId)
    ) {
      const bm_3dPreview_variant = bm_3dPreview_productData.variants.find(
        (bm_3dPreview_item) =>
          Number(bm_3dPreview_item?.id) === bm_3dPreview_variantId
      );
      const bm_3dPreview_value =
        bm_3dPreview_variant?.options?.[bm_3dPreview_optionIndex] ??
        bm_3dPreview_variant?.[`option${bm_3dPreview_optionIndex + 1}`];
      const bm_3dPreview_key = bm_3dPreview_woodKeyFromValue(
        controller,
        bm_3dPreview_value
      );
      if (bm_3dPreview_key) return bm_3dPreview_key;
    }

    if (bm_3dPreview_form) {
      const bm_3dPreview_controls = bm_3dPreview_form.querySelectorAll(
        'input[name^="options["], select[name^="options["]'
      );
      const bm_3dPreview_optionName = bm_3dPreview_normalizedLabel(
        controller.config.materialOptionName
      );
      for (const bm_3dPreview_control of bm_3dPreview_controls) {
        const bm_3dPreview_nameMatch = String(
          bm_3dPreview_control.name || ''
        ).match(/^options\[(.*)]$/);
        if (
          !bm_3dPreview_nameMatch ||
          bm_3dPreview_normalizedLabel(bm_3dPreview_nameMatch[1]) !==
            bm_3dPreview_optionName ||
          (bm_3dPreview_control.type === 'radio' &&
            !bm_3dPreview_control.checked)
        ) {
          continue;
        }
        const bm_3dPreview_key = bm_3dPreview_woodKeyFromValue(
          controller,
          bm_3dPreview_control.value
        );
        if (bm_3dPreview_key) return bm_3dPreview_key;
      }
    }

    return '';
  }

  function bm_3dPreview_syncMaterialVariant(controller) {
    if (controller.destroyed || controller.config.frameSource !== 'component_glb') {
      return;
    }
    const bm_3dPreview_key = bm_3dPreview_currentWoodKey(controller);
    if (!bm_3dPreview_key || bm_3dPreview_key === controller.currentWoodKey) {
      return;
    }

    controller.currentWoodKey = bm_3dPreview_key;
    if (controller.componentMaterial) {
      void bm_3dPreview_applyWoodTexture(controller, bm_3dPreview_key);
    }
  }

  function bm_3dPreview_initMaterialVariantBridge(controller) {
    if (controller.config.frameSource !== 'component_glb') return;

    const bm_3dPreview_sync = () => {
      window.setTimeout(() => bm_3dPreview_syncMaterialVariant(controller), 0);
    };
    const bm_3dPreview_changeHandler = (event) => {
      const bm_3dPreview_name = String(event.target?.name || '');
      if (
        bm_3dPreview_name === 'id' ||
        bm_3dPreview_name.startsWith('options[')
      ) {
        bm_3dPreview_sync();
      }
    };

    document.addEventListener('change', bm_3dPreview_changeHandler, true);
    BM_3D_PREVIEW_VARIANT_EVENTS.forEach((bm_3dPreview_eventName) => {
      document.addEventListener(bm_3dPreview_eventName, bm_3dPreview_sync);
    });
    controller.cleanupCallbacks.push(() => {
      document.removeEventListener('change', bm_3dPreview_changeHandler, true);
      BM_3D_PREVIEW_VARIANT_EVENTS.forEach((bm_3dPreview_eventName) => {
        document.removeEventListener(bm_3dPreview_eventName, bm_3dPreview_sync);
      });
    });

    controller.currentWoodKey =
      bm_3dPreview_currentWoodKey(controller) ||
      (controller.config.designMode ? 'oak' : '');
  }

  function bm_3dPreview_updateColorPicker(controller) {
    const bm_3dPreview_picker = controller.nodes.colorPicker;
    const bm_3dPreview_previewColor = bm_3dPreview_selectedColor(controller);
    const bm_3dPreview_cartColor = controller.cartColor;
    if (bm_3dPreview_picker && controller.materials.length) {
      bm_3dPreview_picker.hidden = false;
      controller.nodes.colorOptions
        .querySelectorAll('[data-bm-color-id]')
        .forEach((bm_3dPreview_button) => {
          const bm_3dPreview_isPreview =
            bm_3dPreview_button.dataset.bmColorId === bm_3dPreview_previewColor.id;
          const bm_3dPreview_isCart =
            bm_3dPreview_button.dataset.bmColorId === bm_3dPreview_cartColor?.id;
          bm_3dPreview_button.classList.toggle(
            'bm_3dPreview_selectedColor',
            bm_3dPreview_isPreview
          );
          bm_3dPreview_button.classList.toggle(
            'bm_3dPreview_cartColor',
            bm_3dPreview_isCart
          );
          bm_3dPreview_button.setAttribute('aria-checked', String(bm_3dPreview_isPreview));
          bm_3dPreview_button.setAttribute(
            'aria-label',
            bm_3dPreview_isCart
              ? `${bm_3dPreview_button.textContent}: Warenkorbfarbe`
              : String(bm_3dPreview_button.textContent || '')
          );
        });
    }
    const bm_3dPreview_mapMode = bm_3dPreview_previewColor.mapMode;
    if (controller.nodes.mapAttribution) {
      controller.nodes.mapAttribution.hidden = bm_3dPreview_mapMode === 'none';
    }
    if (controller.nodes.osmMapAttribution) {
      controller.nodes.osmMapAttribution.hidden =
        !['osm', 'water', 'topographic'].includes(bm_3dPreview_mapMode);
    }
    if (controller.nodes.satelliteMapAttribution) {
      controller.nodes.satelliteMapAttribution.hidden =
        bm_3dPreview_mapMode !== 'satellite';
    }
    const bm_3dPreview_cartMismatch = Boolean(
      bm_3dPreview_cartColor?.id &&
      bm_3dPreview_previewColor?.id &&
      bm_3dPreview_cartColor.id !== bm_3dPreview_previewColor.id
    );
    if (controller.nodes.cartMismatchNotice) {
      controller.nodes.cartMismatchNotice.hidden = !bm_3dPreview_cartMismatch;
    }
  }

  function bm_3dPreview_renderColorPicker(controller) {
    const bm_3dPreview_picker = controller.nodes.colorPicker;
    const bm_3dPreview_options = controller.nodes.colorOptions;
    if (!bm_3dPreview_picker || !bm_3dPreview_options || !controller.materials.length) {
      return;
    }

    bm_3dPreview_options.replaceChildren();
    controller.materials.forEach((bm_3dPreview_material) => {
      const bm_3dPreview_presentation = bm_3dPreview_themeSwatchPresentation(
        controller,
        bm_3dPreview_material
      );
      const bm_3dPreview_button = document.createElement('button');
      bm_3dPreview_button.type = 'button';
      bm_3dPreview_button.className = 'bm_3dPreview_variantButton';
      bm_3dPreview_button.dataset.bmColorId = bm_3dPreview_material.id;
      bm_3dPreview_button.setAttribute('role', 'radio');
      bm_3dPreview_button.setAttribute('aria-checked', 'false');
      bm_3dPreview_button.style.setProperty(
        '--bm-3dPreview-swatch-color',
        bm_3dPreview_presentation.swatchColor || bm_3dPreview_material.swatchColor
      );
      if (bm_3dPreview_presentation.imageUrl) {
        const bm_3dPreview_image = document.createElement('img');
        bm_3dPreview_image.className = 'bm_3dPreview_variantImage';
        bm_3dPreview_image.src = bm_3dPreview_presentation.imageUrl;
        bm_3dPreview_image.alt = '';
        bm_3dPreview_image.decoding = 'async';
        bm_3dPreview_button.classList.add('bm_3dPreview_variantButton--image');
        bm_3dPreview_button.appendChild(bm_3dPreview_image);
      }
      const bm_3dPreview_label = document.createElement('span');
      bm_3dPreview_label.className = 'bm_3dPreview_variantLabel';
      bm_3dPreview_label.textContent = bm_3dPreview_presentation.label;
      bm_3dPreview_button.appendChild(bm_3dPreview_label);
      bm_3dPreview_button.addEventListener('click', () => {
        bm_3dPreview_selectColor(controller, bm_3dPreview_material);
      });
      bm_3dPreview_options.appendChild(bm_3dPreview_button);
    });
    bm_3dPreview_updateColorPicker(controller);
  }

  function bm_3dPreview_applySelectedColor(controller, material) {
    if (!material || controller.selectedColor?.id === material.id) return;
    controller.selectedColor = material;
    bm_3dPreview_updateColorPicker(controller);
    if (controller.hasReadyModel) {
      bm_3dPreview_load(controller, { preserveCamera: true });
    }
  }

  function bm_3dPreview_selectColor(controller, material) {
    if (controller.destroyed) return;
    controller.surfaceBaseColor = material;
    bm_3dPreview_applySelectedColor(controller, material);
  }

  function bm_3dPreview_syncColorVariant(controller) {
    if (controller.destroyed || !controller.materials.length) return;
    const bm_3dPreview_valueKey = bm_3dPreview_normalizedLabel(
      bm_3dPreview_currentColorValue(controller)
    );
    const bm_3dPreview_material = controller.materials.find(
      (bm_3dPreview_item) => bm_3dPreview_item.variantValueKey === bm_3dPreview_valueKey
    );
    if (!bm_3dPreview_material) return;

    controller.cartColor = bm_3dPreview_material;
    controller.surfaceBaseColor = bm_3dPreview_material;
    bm_3dPreview_applySelectedColor(controller, bm_3dPreview_material);
    bm_3dPreview_renderColorPicker(controller);
  }

  function bm_3dPreview_resetPreview(controller) {
    bm_3dPreview_resetCamera(controller);
    if (controller.cartColor) {
      bm_3dPreview_applySelectedColor(controller, controller.cartColor);
    }
  }

  function bm_3dPreview_initColorInfo(controller) {
    const bm_3dPreview_button = controller.nodes.colorInfoButton;
    const bm_3dPreview_panel = controller.nodes.colorInfoPanel;
    if (!bm_3dPreview_button || !bm_3dPreview_panel) return;

    let bm_3dPreview_pinned = false;
    const bm_3dPreview_setOpen = (isOpen) => {
      bm_3dPreview_panel.hidden = !isOpen;
      bm_3dPreview_button.setAttribute('aria-expanded', String(isOpen));
    };
    const bm_3dPreview_clickHandler = () => {
      bm_3dPreview_pinned = !bm_3dPreview_pinned;
      bm_3dPreview_setOpen(bm_3dPreview_pinned);
    };
    const bm_3dPreview_enterHandler = () => bm_3dPreview_setOpen(true);
    const bm_3dPreview_leaveHandler = () => {
      if (!bm_3dPreview_pinned) bm_3dPreview_setOpen(false);
    };
    bm_3dPreview_button.addEventListener('click', bm_3dPreview_clickHandler);
    bm_3dPreview_button.addEventListener('pointerenter', bm_3dPreview_enterHandler);
    bm_3dPreview_button.addEventListener('pointerleave', bm_3dPreview_leaveHandler);
    bm_3dPreview_panel.addEventListener('pointerenter', bm_3dPreview_enterHandler);
    bm_3dPreview_panel.addEventListener('pointerleave', bm_3dPreview_leaveHandler);
    controller.cleanupCallbacks.push(() => {
      bm_3dPreview_button.removeEventListener('click', bm_3dPreview_clickHandler);
      bm_3dPreview_button.removeEventListener('pointerenter', bm_3dPreview_enterHandler);
      bm_3dPreview_button.removeEventListener('pointerleave', bm_3dPreview_leaveHandler);
      bm_3dPreview_panel.removeEventListener('pointerenter', bm_3dPreview_enterHandler);
      bm_3dPreview_panel.removeEventListener('pointerleave', bm_3dPreview_leaveHandler);
    });
  }

  function bm_3dPreview_initColorVariantBridge(controller) {
    if (controller.colorOptionIndex < 0 || !controller.nodes.colorPicker) return;
    const bm_3dPreview_sync = () => {
      window.setTimeout(() => bm_3dPreview_syncColorVariant(controller), 0);
    };
    const bm_3dPreview_changeHandler = (event) => {
      const bm_3dPreview_name = String(event.target?.name || '');
      if (bm_3dPreview_name === 'id' || bm_3dPreview_name.startsWith('options[')) {
        bm_3dPreview_sync();
      }
    };
    document.addEventListener('change', bm_3dPreview_changeHandler, true);
    BM_3D_PREVIEW_VARIANT_EVENTS.forEach((bm_3dPreview_eventName) => {
      document.addEventListener(bm_3dPreview_eventName, bm_3dPreview_sync);
    });
    controller.cleanupCallbacks.push(() => {
      document.removeEventListener('change', bm_3dPreview_changeHandler, true);
      BM_3D_PREVIEW_VARIANT_EVENTS.forEach((bm_3dPreview_eventName) => {
        document.removeEventListener(bm_3dPreview_eventName, bm_3dPreview_sync);
      });
    });

    const bm_3dPreview_form = bm_3dPreview_findProductForm(controller);
    if (window.MutationObserver && bm_3dPreview_form) {
      const bm_3dPreview_observer = new MutationObserver(() => {
        window.clearTimeout(controller.colorUiTimeoutId);
        controller.colorUiTimeoutId = window.setTimeout(() => {
          if (!controller.destroyed) bm_3dPreview_syncColorVariant(controller);
        }, 50);
      });
      bm_3dPreview_observer.observe(bm_3dPreview_form, {
        attributes: true,
        attributeFilter: ['src', 'style', 'aria-label', 'data-option-value'],
        childList: true,
        subtree: true
      });
      controller.cleanupCallbacks.push(() => {
        bm_3dPreview_observer.disconnect();
        window.clearTimeout(controller.colorUiTimeoutId);
      });
    }
  }

  function bm_3dPreview_failure(adminKey, customerMessage) {
    const bm_3dPreview_error = new Error();
    bm_3dPreview_error.bm_3dPreview_adminKey = adminKey;
    bm_3dPreview_error.bm_3dPreview_customerMessage = customerMessage;
    return bm_3dPreview_error;
  }

  function bm_3dPreview_isAbort(error) {
    return error && (error.name === 'AbortError' || error.name === 'AbortSignal');
  }

  function bm_3dPreview_parseAdminMessages(root) {
    const bm_3dPreview_node = root.querySelector('[data-bm-role="admin-messages"]');
    if (!bm_3dPreview_node) return {};

    try {
      const bm_3dPreview_messages = JSON.parse(bm_3dPreview_node.textContent || '{}');
      return bm_3dPreview_messages && typeof bm_3dPreview_messages === 'object'
        ? bm_3dPreview_messages
        : {};
    } catch (_bm_3dPreview_error) {
      return {};
    }
  }

  function bm_3dPreview_setStatus(controller, message, type = '') {
    const bm_3dPreview_hideNoncritical =
      controller.root.dataset.bmStatusVisibility === 'errors_only';
    let bm_3dPreview_message =
      bm_3dPreview_hideNoncritical && type === 'warning' ? '' : message;
    let bm_3dPreview_type = bm_3dPreview_message ? type : '';
    const bm_3dPreview_contactText = String(
      controller.root.dataset.bmErrorContactText || ''
    ).trim();
    if (
      bm_3dPreview_message &&
      bm_3dPreview_type === 'error' &&
      bm_3dPreview_contactText &&
      !String(bm_3dPreview_message).includes(bm_3dPreview_contactText)
    ) {
      bm_3dPreview_message = `${bm_3dPreview_message} ${bm_3dPreview_contactText}`;
    }

    controller.nodes.status.textContent = bm_3dPreview_message;
    controller.nodes.status.hidden = !bm_3dPreview_message;
    controller.nodes.status.dataset.bmStatusType = bm_3dPreview_type;
  }

  function bm_3dPreview_setAdminStatus(controller, adminKey) {
    const bm_3dPreview_adminNode = controller.nodes.adminStatus;
    if (!bm_3dPreview_adminNode) return;

    const bm_3dPreview_message = controller.adminMessages[adminKey] || '';
    bm_3dPreview_adminNode.textContent = bm_3dPreview_message;
    bm_3dPreview_adminNode.hidden = !bm_3dPreview_message;
  }

  function bm_3dPreview_setBusy(controller, isBusy) {
    controller.nodes.stage.setAttribute('aria-busy', String(isBusy));
    controller.root.classList.toggle('bm_3dPreview_root--loading', isBusy);
    controller.nodes.loadButton.disabled = isBusy;
  }

  function bm_3dPreview_handleFailure(controller, error, fallbackAdminKey = 'render') {
    if (controller.destroyed || bm_3dPreview_isAbort(error)) return;

    let bm_3dPreview_customerMessage =
      error?.bm_3dPreview_customerMessage ||
      'Die 3D-Vorschau ist derzeit nicht verfügbar.';
    const bm_3dPreview_adminKey = error?.bm_3dPreview_adminKey || fallbackAdminKey;
    if (['catalog', 'coverage', 'tile', 'raster', 'crs'].includes(bm_3dPreview_adminKey)) {
      bm_3dPreview_customerMessage =
        'Für diesen Ausschnitt sind noch keine Höhendaten in der Vorschau verfügbar. Bitte sende uns eine Anfrage – wir senden dir gerne eine Vorschau.';
    }

    bm_3dPreview_setBusy(controller, false);
    bm_3dPreview_setStatus(controller, bm_3dPreview_customerMessage, 'error');
    bm_3dPreview_setAdminStatus(controller, bm_3dPreview_adminKey);

    if (!controller.hasReadyModel) {
      controller.root.classList.remove('bm_3dPreview_root--ready');
      controller.nodes.loadButton.disabled = false;
    }
  }

  function bm_3dPreview_loadVendor(vendorUrl) {
    if (!vendorUrl) {
      return Promise.reject(
        bm_3dPreview_failure('library', 'Die 3D-Vorschau ist derzeit nicht verfügbar.')
      );
    }

    if (bm_3dPreview_vendorPromises.has(vendorUrl)) {
      return bm_3dPreview_vendorPromises.get(vendorUrl);
    }

    const bm_3dPreview_promise = import(vendorUrl)
      .then((bm_3dPreview_vendor) => {
        if (
          !bm_3dPreview_vendor?.THREE?.WebGLRenderer ||
          typeof bm_3dPreview_vendor.OrbitControls !== 'function' ||
          typeof bm_3dPreview_vendor.GLTFLoader !== 'function' ||
          typeof bm_3dPreview_vendor.fromUrl !== 'function'
        ) {
          throw bm_3dPreview_failure(
            'library',
            'Die 3D-Vorschau ist derzeit nicht verfügbar.'
          );
        }
        return bm_3dPreview_vendor;
      })
      .catch((bm_3dPreview_error) => {
        bm_3dPreview_vendorPromises.delete(vendorUrl);
        if (bm_3dPreview_error?.bm_3dPreview_adminKey) throw bm_3dPreview_error;
        throw bm_3dPreview_failure(
          'library',
          'Die 3D-Vorschau ist derzeit nicht verfügbar.'
        );
      });

    bm_3dPreview_vendorPromises.set(vendorUrl, bm_3dPreview_promise);
    return bm_3dPreview_promise;
  }

  function bm_3dPreview_loadFeatureModule(moduleUrl, factoryName) {
    if (typeof window.BM[factoryName] === 'function') {
      return Promise.resolve();
    }
    if (!moduleUrl) {
      return Promise.reject(
        bm_3dPreview_failure('library', 'Die 3D-Vorschau ist derzeit nicht verfügbar.')
      );
    }
    if (bm_3dPreview_modulePromises.has(moduleUrl)) {
      return bm_3dPreview_modulePromises.get(moduleUrl);
    }

    const bm_3dPreview_promise = import(moduleUrl)
      .then(() => {
        if (typeof window.BM[factoryName] !== 'function') {
          throw bm_3dPreview_failure(
            'library',
            'Die 3D-Vorschau ist derzeit nicht verfügbar.'
          );
        }
      })
      .catch((bm_3dPreview_error) => {
        bm_3dPreview_modulePromises.delete(moduleUrl);
        if (bm_3dPreview_error?.bm_3dPreview_adminKey) throw bm_3dPreview_error;
        throw bm_3dPreview_failure(
          'library',
          'Die 3D-Vorschau ist derzeit nicht verfügbar.'
        );
      });
    bm_3dPreview_modulePromises.set(moduleUrl, bm_3dPreview_promise);
    return bm_3dPreview_promise;
  }

  function bm_3dPreview_derivedGpxModuleUrl(config) {
    const bm_3dPreview_siblingUrl =
      config.terrainModuleUrl || config.modelModuleUrl || config.mapModuleUrl;
    if (!bm_3dPreview_siblingUrl) return '';

    try {
      const bm_3dPreview_url = new URL(bm_3dPreview_siblingUrl);
      const bm_3dPreview_pattern = /bm_3dPreview_(?:terrain|model|map)\.js$/;
      if (!bm_3dPreview_pattern.test(bm_3dPreview_url.pathname)) return '';
      bm_3dPreview_url.pathname = bm_3dPreview_url.pathname.replace(
        bm_3dPreview_pattern,
        'bm_3dPreview_gpx.js'
      );
      return bm_3dPreview_httpsUrl(bm_3dPreview_url.href);
    } catch (_bm_3dPreview_derivationError) {
      return '';
    }
  }

  function bm_3dPreview_loadGpxService(config) {
    const bm_3dPreview_moduleUrl =
      config.gpxModuleUrl || bm_3dPreview_derivedGpxModuleUrl(config);
    if (!bm_3dPreview_moduleUrl) return Promise.resolve();

    return bm_3dPreview_loadFeatureModule(
      bm_3dPreview_moduleUrl,
      'bm_3dPreview_createGpxService'
    ).catch(() => {
      window.console?.warn?.(
        '[bm_3dPreview_viewer] bm_3dPreview_gpx.js konnte nicht geladen werden: ' +
          `${bm_3dPreview_moduleUrl} – die 3D-Vorschau läuft ohne GPS-Track weiter.`
      );
    });
  }

  function bm_3dPreview_loadServices(config) {
    if (bm_3dPreview_servicesReady) return Promise.resolve();
    if (bm_3dPreview_servicesPromise) return bm_3dPreview_servicesPromise;

    bm_3dPreview_servicesPromise = Promise.all([
      bm_3dPreview_loadFeatureModule(
        config.terrainModuleUrl,
        'bm_3dPreview_createTerrainService'
      ),
      bm_3dPreview_loadFeatureModule(
        config.mapModuleUrl,
        'bm_3dPreview_createMapService'
      ),
      bm_3dPreview_loadFeatureModule(
        config.modelModuleUrl,
        'bm_3dPreview_createModelService'
      ),
      bm_3dPreview_loadGpxService(config)
    ])
      .then(() => {
        if (!bm_3dPreview_initializeServices()) {
          throw bm_3dPreview_failure(
            'library',
            'Die 3D-Vorschau ist derzeit nicht verfügbar.'
          );
        }
        bm_3dPreview_servicesReady = true;
      })
      .catch((bm_3dPreview_error) => {
        bm_3dPreview_servicesPromise = null;
        if (bm_3dPreview_error?.bm_3dPreview_adminKey) throw bm_3dPreview_error;
        throw bm_3dPreview_failure(
          'library',
          'Die 3D-Vorschau ist derzeit nicht verfügbar.'
        );
      });
    return bm_3dPreview_servicesPromise;
  }

  function bm_3dPreview_abortError() {
    const bm_3dPreview_error = new Error();
    bm_3dPreview_error.name = 'AbortError';
    return bm_3dPreview_error;
  }

  function bm_3dPreview_throwIfAborted(signal) {
    if (signal?.aborted) throw bm_3dPreview_abortError();
  }

  function bm_3dPreview_createScene(controller) {
    if (controller.sceneState) return controller.sceneState;

    const { THREE, OrbitControls } = controller.vendor;
    let bm_3dPreview_renderer;

    try {
      bm_3dPreview_renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: false,
        powerPreference: 'high-performance',
        preserveDrawingBuffer: false
      });
    } catch (_bm_3dPreview_error) {
      throw bm_3dPreview_failure('webgl', 'Dieses Gerät unterstützt die 3D-Vorschau nicht.');
    }

    const bm_3dPreview_scene = new THREE.Scene();
    const bm_3dPreview_camera = new THREE.PerspectiveCamera(42, 1, 0.01, 100);
    const bm_3dPreview_modelRoot = new THREE.Group();
    bm_3dPreview_modelRoot.name = 'bm_3dPreview_modelRoot';
    bm_3dPreview_scene.add(bm_3dPreview_modelRoot);

    bm_3dPreview_renderer.setClearColor(controller.config.backgroundColor, 1);
    bm_3dPreview_renderer.outputColorSpace = THREE.SRGBColorSpace;
    bm_3dPreview_renderer.toneMapping = THREE.ACESFilmicToneMapping;
    bm_3dPreview_renderer.toneMappingExposure = 1.05;

    const bm_3dPreview_canvas = bm_3dPreview_renderer.domElement;
    bm_3dPreview_canvas.tabIndex = 0;
    bm_3dPreview_canvas.setAttribute(
      'aria-label',
      controller.nodes.canvasHost.dataset.bmCanvasLabel || 'Interaktive 3D-Vorschau'
    );
    controller.nodes.canvasHost.replaceChildren(bm_3dPreview_canvas);

    const bm_3dPreview_controls = new OrbitControls(
      bm_3dPreview_camera,
      bm_3dPreview_canvas
    );
    bm_3dPreview_controls.enableDamping = false;
    bm_3dPreview_controls.enablePan = true;
    bm_3dPreview_controls.minPolarAngle = 0.12;
    bm_3dPreview_controls.maxPolarAngle = Math.PI * 0.49;
    bm_3dPreview_controls.panSpeed = BM_3D_PREVIEW_PAN_SPEED;
    bm_3dPreview_controls.rotateSpeed = 0.75;
    bm_3dPreview_controls.screenSpacePanning = true;
    bm_3dPreview_controls.zoomSpeed = 0.8;
    bm_3dPreview_controls.listenToKeyEvents?.(bm_3dPreview_canvas);

    const bm_3dPreview_hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x5d5549, 0.95);
    bm_3dPreview_hemisphereLight.name = 'bm_3dPreview_hemisphereLight';
    bm_3dPreview_scene.add(bm_3dPreview_hemisphereLight);

    const bm_3dPreview_keyLight = new THREE.DirectionalLight(0xffffff, 1.5);
    bm_3dPreview_keyLight.name = 'bm_3dPreview_keyLight';
    bm_3dPreview_keyLight.position.set(4, 7, 5);
    bm_3dPreview_scene.add(bm_3dPreview_keyLight);

    const bm_3dPreview_backLeftLight = new THREE.DirectionalLight(0xdce8ff, 2.8);
    bm_3dPreview_backLeftLight.name = 'bm_3dPreview_backLeftLight';
    bm_3dPreview_scene.add(bm_3dPreview_backLeftLight);
    bm_3dPreview_scene.add(bm_3dPreview_backLeftLight.target);

    const bm_3dPreview_sceneState = {
      scene: bm_3dPreview_scene,
      camera: bm_3dPreview_camera,
      renderer: bm_3dPreview_renderer,
      controls: bm_3dPreview_controls,
      modelRoot: bm_3dPreview_modelRoot,
      cameraLight: bm_3dPreview_backLeftLight,
      currentModel: null,
      initialCameraPosition: new THREE.Vector3(3.6, 2.7, 3.6),
      initialTarget: new THREE.Vector3(0, 0.25, 0),
      resizeObserver: null,
      renderPending: false
    };

    controller.sceneState = bm_3dPreview_sceneState;

    const bm_3dPreview_renderHandler = () => bm_3dPreview_scheduleRender(controller);
    bm_3dPreview_controls.addEventListener('change', bm_3dPreview_renderHandler);
    controller.cleanupCallbacks.push(() => {
      bm_3dPreview_controls.removeEventListener('change', bm_3dPreview_renderHandler);
    });

    const bm_3dPreview_contextLostHandler = (event) => {
      event.preventDefault();
      bm_3dPreview_handleFailure(
        controller,
        bm_3dPreview_failure('render', 'Die 3D-Darstellung wurde unterbrochen.')
      );
    };
    const bm_3dPreview_contextRestoredHandler = () => {
      bm_3dPreview_setStatus(controller, '');
      bm_3dPreview_setAdminStatus(controller, '');
      bm_3dPreview_scheduleRender(controller);
    };
    bm_3dPreview_canvas.addEventListener('webglcontextlost', bm_3dPreview_contextLostHandler);
    bm_3dPreview_canvas.addEventListener(
      'webglcontextrestored',
      bm_3dPreview_contextRestoredHandler
    );
    controller.cleanupCallbacks.push(() => {
      bm_3dPreview_canvas.removeEventListener(
        'webglcontextlost',
        bm_3dPreview_contextLostHandler
      );
      bm_3dPreview_canvas.removeEventListener(
        'webglcontextrestored',
        bm_3dPreview_contextRestoredHandler
      );
    });

    if (typeof ResizeObserver === 'function') {
      bm_3dPreview_sceneState.resizeObserver = new ResizeObserver(() => {
        bm_3dPreview_resize(controller);
      });
      bm_3dPreview_sceneState.resizeObserver.observe(controller.nodes.canvasHost);
    } else {
      const bm_3dPreview_resizeHandler = () => bm_3dPreview_resize(controller);
      window.addEventListener('resize', bm_3dPreview_resizeHandler, { passive: true });
      controller.cleanupCallbacks.push(() => {
        window.removeEventListener('resize', bm_3dPreview_resizeHandler);
      });
    }

    bm_3dPreview_resize(controller);
    return bm_3dPreview_sceneState;
  }

  function bm_3dPreview_resize(controller) {
    const bm_3dPreview_sceneState = controller.sceneState;
    if (!bm_3dPreview_sceneState) return;

    const bm_3dPreview_bounds = controller.nodes.canvasHost.getBoundingClientRect();
    const bm_3dPreview_width = Math.max(1, Math.round(bm_3dPreview_bounds.width));
    const bm_3dPreview_height = Math.max(1, Math.round(bm_3dPreview_bounds.height));
    const bm_3dPreview_pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5);

    bm_3dPreview_sceneState.renderer.setPixelRatio(bm_3dPreview_pixelRatio);
    bm_3dPreview_sceneState.renderer.setSize(
      bm_3dPreview_width,
      bm_3dPreview_height,
      false
    );
    bm_3dPreview_sceneState.camera.aspect = bm_3dPreview_width / bm_3dPreview_height;
    bm_3dPreview_sceneState.camera.updateProjectionMatrix();
    bm_3dPreview_scheduleRender(controller);
  }

  function bm_3dPreview_updateCameraLight(controller) {
    const bm_3dPreview_sceneState = controller.sceneState;
    const bm_3dPreview_light = bm_3dPreview_sceneState?.cameraLight;
    if (!bm_3dPreview_light) return;

    const { THREE } = controller.vendor;
    const bm_3dPreview_camera = bm_3dPreview_sceneState.camera;
    const bm_3dPreview_target = bm_3dPreview_sceneState.controls.target;
    const bm_3dPreview_distance = Math.max(
      bm_3dPreview_camera.position.distanceTo(bm_3dPreview_target),
      1
    );
    const bm_3dPreview_forward = new THREE.Vector3();
    const bm_3dPreview_right = new THREE.Vector3();
    const bm_3dPreview_up = new THREE.Vector3(0, 1, 0);

    bm_3dPreview_camera.getWorldDirection(bm_3dPreview_forward);
    bm_3dPreview_right.crossVectors(bm_3dPreview_forward, bm_3dPreview_up).normalize();
    bm_3dPreview_light.position
      .copy(bm_3dPreview_camera.position)
      .addScaledVector(bm_3dPreview_right, -bm_3dPreview_distance * 0.42)
      .addScaledVector(bm_3dPreview_up, bm_3dPreview_distance * 0.32);
    bm_3dPreview_light.target.position.copy(bm_3dPreview_target);
    bm_3dPreview_light.target.updateMatrixWorld();
    bm_3dPreview_light.updateMatrixWorld();
  }

  function bm_3dPreview_scheduleRender(controller) {
    const bm_3dPreview_sceneState = controller.sceneState;
    if (!bm_3dPreview_sceneState || bm_3dPreview_sceneState.renderPending) return;

    bm_3dPreview_sceneState.renderPending = true;
    window.requestAnimationFrame(() => {
      bm_3dPreview_sceneState.renderPending = false;
      if (controller.destroyed) return;

      try {
        bm_3dPreview_updateCameraLight(controller);
        bm_3dPreview_sceneState.renderer.render(
          bm_3dPreview_sceneState.scene,
          bm_3dPreview_sceneState.camera
        );
      } catch (_bm_3dPreview_error) {
        bm_3dPreview_handleFailure(
          controller,
          bm_3dPreview_failure('render', 'Die 3D-Vorschau konnte nicht dargestellt werden.')
        );
      }
    });
  }

  function bm_3dPreview_disposeMaterial(
    material,
    disposedMaterials = new Set(),
    disposedTextures = new Set()
  ) {
    if (!material || disposedMaterials.has(material)) return;
    disposedMaterials.add(material);
    for (const bm_3dPreview_value of Object.values(material)) {
      if (
        bm_3dPreview_value?.isTexture &&
        !disposedTextures.has(bm_3dPreview_value)
      ) {
        disposedTextures.add(bm_3dPreview_value);
        bm_3dPreview_value.source?.data?.close?.();
        bm_3dPreview_value.dispose();
      }
    }
    material.dispose?.();
  }

  function bm_3dPreview_disposeObject(object) {
    if (!object?.traverse) return;
    const bm_3dPreview_disposedGeometries = new Set();
    const bm_3dPreview_disposedMaterials = new Set();
    const bm_3dPreview_disposedTextures = new Set();
    object.traverse((bm_3dPreview_child) => {
      if (
        bm_3dPreview_child.geometry &&
        !bm_3dPreview_disposedGeometries.has(bm_3dPreview_child.geometry)
      ) {
        bm_3dPreview_disposedGeometries.add(bm_3dPreview_child.geometry);
        bm_3dPreview_child.geometry.dispose?.();
      }
      if (Array.isArray(bm_3dPreview_child.material)) {
        bm_3dPreview_child.material.forEach((bm_3dPreview_material) => {
          bm_3dPreview_disposeMaterial(
            bm_3dPreview_material,
            bm_3dPreview_disposedMaterials,
            bm_3dPreview_disposedTextures
          );
        });
      } else {
        bm_3dPreview_disposeMaterial(
          bm_3dPreview_child.material,
          bm_3dPreview_disposedMaterials,
          bm_3dPreview_disposedTextures
        );
      }
    });
  }

  function bm_3dPreview_fitCamera(controller, object) {
    const { THREE } = controller.vendor;
    const bm_3dPreview_sceneState = controller.sceneState;
    const bm_3dPreview_box = new THREE.Box3().setFromObject(object);
    const bm_3dPreview_sphere = bm_3dPreview_box.getBoundingSphere(new THREE.Sphere());
    const bm_3dPreview_radius = Math.max(0.5, bm_3dPreview_sphere.radius);
    const bm_3dPreview_target = bm_3dPreview_sphere.center.clone();
    const bm_3dPreview_direction = new THREE.Vector3(1.15, 0.86, 1.15).normalize();
    const bm_3dPreview_halfFov =
      (bm_3dPreview_sceneState.camera.fov * Math.PI) / 360;
    const bm_3dPreview_distance = (bm_3dPreview_radius / Math.sin(bm_3dPreview_halfFov)) * 1.18;
    const bm_3dPreview_position = bm_3dPreview_target
      .clone()
      .addScaledVector(bm_3dPreview_direction, bm_3dPreview_distance);

    bm_3dPreview_sceneState.camera.position.copy(bm_3dPreview_position);
    bm_3dPreview_sceneState.camera.near = Math.max(0.005, bm_3dPreview_distance / 100);
    bm_3dPreview_sceneState.camera.far = bm_3dPreview_distance * 20;
    bm_3dPreview_sceneState.camera.updateProjectionMatrix();
    bm_3dPreview_sceneState.controls.target.copy(bm_3dPreview_target);
    bm_3dPreview_sceneState.controls.cursor.copy(bm_3dPreview_target);
    bm_3dPreview_sceneState.controls.minDistance = bm_3dPreview_radius * 0.75;
    bm_3dPreview_sceneState.controls.maxDistance = bm_3dPreview_radius * 6;
    bm_3dPreview_sceneState.controls.minTargetRadius = 0;
    bm_3dPreview_sceneState.controls.maxTargetRadius =
      bm_3dPreview_radius * BM_3D_PREVIEW_MAX_PAN_RADIUS_FACTOR;
    bm_3dPreview_sceneState.controls.update();
    bm_3dPreview_sceneState.initialCameraPosition.copy(bm_3dPreview_position);
    bm_3dPreview_sceneState.initialTarget.copy(bm_3dPreview_target);
  }

  function bm_3dPreview_resetCamera(controller) {
    const bm_3dPreview_sceneState = controller.sceneState;
    if (!bm_3dPreview_sceneState?.currentModel) return;

    bm_3dPreview_sceneState.camera.position.copy(
      bm_3dPreview_sceneState.initialCameraPosition
    );
    bm_3dPreview_sceneState.controls.target.copy(bm_3dPreview_sceneState.initialTarget);
    bm_3dPreview_sceneState.controls.update();
    bm_3dPreview_scheduleRender(controller);
  }

  async function bm_3dPreview_load(controller, options = {}) {
    if (controller.destroyed) return;

    const bm_3dPreview_preserveCamera =
      options.preserveCamera === true && Boolean(controller.sceneState?.currentModel);

    controller.loadGeneration += 1;
    const bm_3dPreview_generation = controller.loadGeneration;
    controller.abortController?.abort();
    controller.abortController = new AbortController();
    const bm_3dPreview_signal = controller.abortController.signal;

    bm_3dPreview_setBusy(controller, true);
    bm_3dPreview_setStatus(
      controller,
      controller.hasReadyModel
        ? '3D-Vorschau wird aktualisiert.'
        : '3D-Vorschau wird geladen.'
    );
    bm_3dPreview_setAdminStatus(controller, '');

    try {
      await bm_3dPreview_loadServices(controller.config);
      if (controller.destroyed || bm_3dPreview_generation !== controller.loadGeneration) return;

      controller.vendor = await bm_3dPreview_loadVendor(controller.config.vendorUrl);
      if (controller.destroyed || bm_3dPreview_generation !== controller.loadGeneration) return;

      bm_3dPreview_createScene(controller);
      const bm_3dPreview_terrainData =
        options.reuseTerrain === true && controller.currentTerrainData
          ? controller.currentTerrainData
          : await bm_3dPreview_readTerrain(controller, bm_3dPreview_signal);
      if (controller.destroyed || bm_3dPreview_generation !== controller.loadGeneration) return;

      const bm_3dPreview_modelResult = await bm_3dPreview_buildModel(
        controller,
        bm_3dPreview_terrainData,
        bm_3dPreview_generation,
        bm_3dPreview_signal
      );
      if (!bm_3dPreview_modelResult || controller.destroyed) return;

      const bm_3dPreview_sceneState = controller.sceneState;
      if (bm_3dPreview_sceneState.currentModel) {
        bm_3dPreview_sceneState.modelRoot.remove(bm_3dPreview_sceneState.currentModel);
        bm_3dPreview_disposeObject(bm_3dPreview_sceneState.currentModel);
      }

      controller.componentMaterial =
        bm_3dPreview_modelResult.componentMaterial;
      controller.componentMaterialKey =
        bm_3dPreview_modelResult.componentMaterialKey;
      bm_3dPreview_sceneState.currentModel = bm_3dPreview_modelResult.object;
      bm_3dPreview_sceneState.modelRoot.add(bm_3dPreview_modelResult.object);
      if (
        controller.componentMaterial &&
        controller.currentWoodKey &&
        controller.currentWoodKey !== controller.componentMaterialKey
      ) {
        void bm_3dPreview_applyWoodTexture(
          controller,
          controller.currentWoodKey
        );
      }
      if (bm_3dPreview_preserveCamera) {
        bm_3dPreview_sceneState.controls.update();
      } else {
        bm_3dPreview_fitCamera(controller, bm_3dPreview_modelResult.object);
      }
      bm_3dPreview_resize(controller);

      controller.hasReadyModel = true;
      controller.currentTerrainData = bm_3dPreview_terrainData;
      const bm_3dPreview_gpxTrackRendered =
        typeof bm_3dPreview_applyGpxTrack === 'function' &&
        bm_3dPreview_applyGpxTrack(controller);
      bm_3dPreview_removeRedundantGpxGeometry(controller);
      controller.root.classList.add('bm_3dPreview_root--ready');
      bm_3dPreview_updateColorPicker(controller);
      bm_3dPreview_setBusy(controller, false);
      if (bm_3dPreview_modelResult.mapTextureFailed) {
        bm_3dPreview_setAdminStatus(controller, 'map_texture');
      } else if (bm_3dPreview_modelResult.printTextureFailed) {
        bm_3dPreview_setAdminStatus(controller, 'print_texture');
      } else if (controller.snowMaskFailed) {
        bm_3dPreview_setAdminStatus(controller, 'snow');
      } else if (controller.glacierMaskFailed) {
        bm_3dPreview_setAdminStatus(controller, 'glacier');
      }

      if (controller.currentGpxTrack && !bm_3dPreview_gpxTrackRendered) {
        bm_3dPreview_setStatus(
          controller,
          bm_3dPreview_gpxWarningMessage(),
          'warning'
        );
      } else if (
        controller.currentGpxTrack &&
        bm_3dPreview_gpxIsPartiallyOutside()
      ) {
        bm_3dPreview_setStatus(
          controller,
          bm_3dPreview_gpxPartialWarningMessage(),
          'warning'
        );
      } else if (bm_3dPreview_terrainData.missingPercent > 0) {
        bm_3dPreview_setStatus(
          controller,
          'Fehlende Einzelwerte wurden sichtbar auf die niedrigste Geländehöhe gesetzt.',
          'warning'
        );
      } else if (bm_3dPreview_modelResult.mapTextureFailed) {
        bm_3dPreview_setStatus(
          controller,
          'Die Oberflächendarstellung konnte nicht geladen werden. Die einfarbige Vorschau wird angezeigt.',
          'warning'
        );
      } else if (bm_3dPreview_modelResult.printTextureFailed) {
        bm_3dPreview_setStatus(
          controller,
          'Die Oberflächentextur konnte nicht geladen werden. Die Standarddarstellung wird angezeigt.',
          'warning'
        );
      } else if (controller.snowMaskFailed) {
        bm_3dPreview_setStatus(
          controller,
          'Die Schneedarstellung konnte nicht geladen werden. Die übrige Vorschau bleibt verfügbar.',
          'warning'
        );
      } else if (controller.glacierMaskFailed) {
        bm_3dPreview_setStatus(
          controller,
          'Die Gletscherdarstellung konnte nicht geladen werden. Die übrige Vorschau bleibt verfügbar.',
          'warning'
        );
      } else {
        bm_3dPreview_setStatus(controller, '');
      }

      controller.root.dispatchEvent(
        new CustomEvent('bm:3dPreview:ready', {
          bubbles: true,
          detail: {
            sectionId: controller.config.sectionId,
            selectionSectionId: bm_3dPreview_terrainData.selection.sectionId,
            gridWidth: bm_3dPreview_terrainData.gridWidth,
            gridHeight: bm_3dPreview_terrainData.gridHeight,
            triangleCount: bm_3dPreview_modelResult.triangleCount,
            minimumElevation: bm_3dPreview_terrainData.minHeight,
            maximumElevation: bm_3dPreview_terrainData.maxHeight,
            missingPercent: bm_3dPreview_terrainData.missingPercent
          }
        })
      );
    } catch (bm_3dPreview_error) {
      if (
        bm_3dPreview_isAbort(bm_3dPreview_error) ||
        bm_3dPreview_generation !== controller.loadGeneration
      ) {
        return;
      }
      bm_3dPreview_handleFailure(controller, bm_3dPreview_error);
    }
  }

  function bm_3dPreview_handleSelectionChange(controller, event) {
    if (controller.config.extentMode !== 'peak_selection') return;

    const bm_3dPreview_selection = bm_3dPreview_cloneSelection(event.detail);
    if (!bm_3dPreview_selection) return;
    if (
      !bm_3dPreview_selectionSectionMatches(
        controller,
        bm_3dPreview_selection.sectionId
      )
    ) {
      bm_3dPreview_gpxDebugLog('selection-change ignoriert: fremde Section', {
        previewSectionId: controller.config.sectionId,
        expectedSelectionSectionId: bm_3dPreview_resolvedSelectionSectionId(controller),
        eventSectionId: bm_3dPreview_selection.sectionId
      });
      return;
    }

    controller.currentSelection = bm_3dPreview_selection;
    if (!controller.config.autoReloadSelection || !controller.hasReadyModel) return;

    window.clearTimeout(controller.selectionTimeoutId);
    controller.selectionTimeoutId = window.setTimeout(() => {
      controller.selectionTimeoutId = null;
      bm_3dPreview_load(controller);
    }, BM_3D_PREVIEW_SELECTION_DEBOUNCE_MS);
  }

  function bm_3dPreview_handleGpxChange(controller, event) {
    const bm_3dPreview_sectionId = String(event.detail?.sectionId || '');
    if (controller.config.extentMode !== 'peak_selection') {
      bm_3dPreview_gpxDebugLog('gpx-change ignoriert: extent_mode', {
        previewSectionId: controller.config.sectionId,
        extentMode: controller.config.extentMode,
        eventSectionId: bm_3dPreview_sectionId
      });
      return;
    }
    if (
      controller.config.selectionSectionId &&
      bm_3dPreview_sectionId !== controller.config.selectionSectionId
    ) {
      bm_3dPreview_gpxDebugLog('gpx-change ignoriert: Section-ID', {
        previewSectionId: controller.config.sectionId,
        expectedSelectionSectionId: controller.config.selectionSectionId,
        eventSectionId: bm_3dPreview_sectionId
      });
      return;
    }

    controller.currentGpxTrack = bm_3dPreview_cloneGpxTrack(event.detail);
    if (controller.currentGpxTrack && bm_3dPreview_sectionId) {
      controller.boundSelectionSectionId = bm_3dPreview_sectionId;
    }
    const bm_3dPreview_currentSelection = bm_3dPreview_cloneSelection(
      event.detail?.selection ||
        window.BM.bm_peakExplorer_getSelection?.(
          controller.config.selectionSectionId || bm_3dPreview_sectionId
        )
    );
    if (bm_3dPreview_currentSelection) {
      controller.currentSelection = bm_3dPreview_currentSelection;
    }
    bm_3dPreview_gpxDebugLog('gpx-change angenommen', {
      previewSectionId: controller.config.sectionId,
      eventSectionId: bm_3dPreview_sectionId,
      eventSegmentCount: Array.isArray(event.detail?.segments)
        ? event.detail.segments.length
        : 0,
      eventPointCount: Number(event.detail?.pointCount || 0),
      clonedTrack: Boolean(controller.currentGpxTrack),
      clonedSegmentCount: controller.currentGpxTrack?.segments?.length || 0,
      clonedPointCount: controller.currentGpxTrack?.pointCount || 0,
      eventSelectionPresent: Boolean(event.detail?.selection),
      clonedSelectionPresent: Boolean(bm_3dPreview_currentSelection),
      clonedSelectionPolygonPoints:
        bm_3dPreview_currentSelection?.polygon?.length || 0,
      hasReadyModel: controller.hasReadyModel,
      applyGpxTrackAvailable: typeof bm_3dPreview_applyGpxTrack === 'function',
      gpxServiceLoaded:
        typeof window.BM.bm_3dPreview_createGpxService === 'function'
    });
    if (!controller.hasReadyModel) return;

    if (!bm_3dPreview_sameSelection(
      controller.currentTerrainData?.selection,
      controller.currentSelection
    )) {
      window.clearTimeout(controller.selectionTimeoutId);
      controller.selectionTimeoutId = null;
      void bm_3dPreview_load(controller);
      return;
    }

    const bm_3dPreview_signature = bm_3dPreview_gpxRenderSignature(
      controller.currentGpxTrack
    );
    if (bm_3dPreview_signature !== controller.gpxRenderSignature) {
      controller.gpxRenderSignature = bm_3dPreview_signature;
      window.clearTimeout(controller.selectionTimeoutId);
      controller.selectionTimeoutId = null;
      void bm_3dPreview_load(controller, {
        preserveCamera: true,
        reuseTerrain: true
      });
      return;
    }

    if (typeof bm_3dPreview_applyGpxTrack === 'function') {
      const bm_3dPreview_gpxTrackRendered = bm_3dPreview_applyGpxTrack(controller);
      bm_3dPreview_removeRedundantGpxGeometry(controller);
      if (controller.currentGpxTrack && !bm_3dPreview_gpxTrackRendered) {
        bm_3dPreview_setStatus(
          controller,
          bm_3dPreview_gpxWarningMessage(),
          'warning'
        );
      } else if (
        controller.currentGpxTrack &&
        bm_3dPreview_gpxIsPartiallyOutside()
      ) {
        bm_3dPreview_setStatus(
          controller,
          bm_3dPreview_gpxPartialWarningMessage(),
          'warning'
        );
      } else if (
        String(controller.nodes.status.textContent || '').startsWith('Der GPS-Track')
      ) {
        bm_3dPreview_setStatus(controller, '');
      }
    }
  }

  function bm_3dPreview_normalizeSnowSettings(input) {
    if (!input || typeof input !== 'object') return null;
    const bm_3dPreview_requestedMode = String(input.mode || '')
      .trim()
      .toLowerCase();
    const bm_3dPreview_hasMode = BM_3D_PREVIEW_SNOW_MODES.includes(
      bm_3dPreview_requestedMode
    );
    const bm_3dPreview_hasEnabled = typeof input.enabled === 'boolean';
    const bm_3dPreview_baseSnowlineM = Number(input.baseSnowlineM);
    const bm_3dPreview_hasBaseSnowline = Number.isFinite(
      bm_3dPreview_baseSnowlineM
    );
    if (
      !bm_3dPreview_hasMode &&
      !bm_3dPreview_hasEnabled &&
      !bm_3dPreview_hasBaseSnowline
    ) {
      return null;
    }

    const bm_3dPreview_settings = {
      sectionId: String(input.sectionId || '').trim()
    };
    if (bm_3dPreview_hasMode) {
      bm_3dPreview_settings.mode = bm_3dPreview_requestedMode;
      bm_3dPreview_settings.enabled = bm_3dPreview_requestedMode !== 'off';
    } else if (bm_3dPreview_hasEnabled) {
      bm_3dPreview_settings.enabled = input.enabled;
      bm_3dPreview_settings.mode = input.enabled ? 'snow' : 'off';
    }
    if (bm_3dPreview_hasBaseSnowline) {
      bm_3dPreview_settings.baseSnowlineM =
        Math.round(
          bm_3dPreview_number(
            bm_3dPreview_baseSnowlineM,
            2400,
            BM_3D_PREVIEW_SNOW_LINE_MIN_M,
            BM_3D_PREVIEW_SNOW_LINE_MAX_M
          ) / BM_3D_PREVIEW_SNOW_LINE_STEP_M
        ) * BM_3D_PREVIEW_SNOW_LINE_STEP_M;
    }
    return Object.freeze(bm_3dPreview_settings);
  }

  function bm_3dPreview_storeSnowOverride(settings) {
    if (!settings) return null;
    const bm_3dPreview_key = settings.sectionId || '*';
    const bm_3dPreview_previous =
      bm_3dPreview_snowOverrides.get(bm_3dPreview_key) || {};
    const bm_3dPreview_merged = Object.freeze({
      ...bm_3dPreview_previous,
      ...settings,
      sectionId: settings.sectionId
    });
    bm_3dPreview_snowOverrides.set(bm_3dPreview_key, bm_3dPreview_merged);
    return bm_3dPreview_merged;
  }

  function bm_3dPreview_snowOverrideFor(sectionId) {
    return (
      bm_3dPreview_snowOverrides.get(String(sectionId || '')) ||
      bm_3dPreview_snowOverrides.get('*') ||
      null
    );
  }

  function bm_3dPreview_snowState(controller) {
    return Object.freeze({
      sectionId: String(controller.config.sectionId || ''),
      enabled: controller.snowEnabled,
      mode: controller.snowMode,
      baseSnowlineM: controller.snowBaseLineM
    });
  }

  function bm_3dPreview_applySnowSettings(
    controller,
    input,
    options = {}
  ) {
    const bm_3dPreview_settings = bm_3dPreview_normalizeSnowSettings(input);
    if (
      !bm_3dPreview_settings ||
      (bm_3dPreview_settings.sectionId &&
        bm_3dPreview_settings.sectionId !== String(controller.config.sectionId))
    ) {
      return false;
    }

    const bm_3dPreview_hasMode = Object.prototype.hasOwnProperty.call(
      bm_3dPreview_settings,
      'mode'
    );
    const bm_3dPreview_hasBaseSnowline = Object.prototype.hasOwnProperty.call(
      bm_3dPreview_settings,
      'baseSnowlineM'
    );
    const bm_3dPreview_modeChanged =
      bm_3dPreview_hasMode &&
      controller.snowMode !== bm_3dPreview_settings.mode;
    const bm_3dPreview_baseSnowlineChanged =
      bm_3dPreview_hasBaseSnowline &&
      controller.snowBaseLineM !== bm_3dPreview_settings.baseSnowlineM;

    if (bm_3dPreview_hasMode) {
      controller.snowMode = bm_3dPreview_settings.mode;
      controller.snowEnabled = bm_3dPreview_settings.mode !== 'off';
    }
    if (bm_3dPreview_hasBaseSnowline) {
      controller.snowBaseLineM = bm_3dPreview_settings.baseSnowlineM;
    }

    const bm_3dPreview_state = bm_3dPreview_snowState(controller);
    bm_3dPreview_snowStates.set(bm_3dPreview_state.sectionId, bm_3dPreview_state);
    if (!bm_3dPreview_modeChanged && !bm_3dPreview_baseSnowlineChanged) {
      return true;
    }

    controller.root.dispatchEvent(
      new CustomEvent(BM_3D_PREVIEW_SNOW_SETTINGS_APPLIED_EVENT, {
        bubbles: true,
        detail: bm_3dPreview_state
      })
    );
    const bm_3dPreview_shouldReload =
      options.reload !== false &&
      controller.hasReadyModel &&
      controller.currentTerrainData &&
      (bm_3dPreview_modeChanged ||
        (bm_3dPreview_baseSnowlineChanged && controller.snowMode === 'snow'));
    if (bm_3dPreview_shouldReload) {
      window.clearTimeout(controller.snowSettingsTimeoutId);
      controller.snowSettingsTimeoutId = window.setTimeout(() => {
        controller.snowSettingsTimeoutId = null;
        void bm_3dPreview_load(controller, {
          preserveCamera: true,
          reuseTerrain: true
        });
      }, BM_3D_PREVIEW_SNOW_SETTINGS_DEBOUNCE_MS);
    }
    return true;
  }

  function bm_3dPreview_initSnowSettingsBridge(controller) {
    const bm_3dPreview_eventHandler = (event) => {
      const bm_3dPreview_settings = bm_3dPreview_normalizeSnowSettings(
        event.detail
      );
      if (!bm_3dPreview_settings) return;
      bm_3dPreview_storeSnowOverride(bm_3dPreview_settings);
      bm_3dPreview_applySnowSettings(controller, bm_3dPreview_settings);
    };
    document.addEventListener(
      BM_3D_PREVIEW_SNOW_SETTINGS_EVENT,
      bm_3dPreview_eventHandler
    );
    controller.cleanupCallbacks.push(() => {
      document.removeEventListener(
        BM_3D_PREVIEW_SNOW_SETTINGS_EVENT,
        bm_3dPreview_eventHandler
      );
    });

    const bm_3dPreview_override = bm_3dPreview_snowOverrideFor(
      controller.config.sectionId
    );
    if (bm_3dPreview_override) {
      bm_3dPreview_applySnowSettings(controller, bm_3dPreview_override, {
        reload: false
      });
    } else {
      const bm_3dPreview_state = bm_3dPreview_snowState(controller);
      bm_3dPreview_snowStates.set(
        bm_3dPreview_state.sectionId,
        bm_3dPreview_state
      );
    }
  }

  function bm_3dPreview_setOverlayOpen(controller, isOpen, shouldLoad = false) {
    if (controller.destroyed) return;
    const bm_3dPreview_wasOpen = controller.root.classList.contains(
      'bm_3dPreview_root--overlayOpen'
    );
    controller.root.classList.toggle('bm_3dPreview_root--overlayOpen', isOpen);
    if (bm_3dPreview_wasOpen !== isOpen) {
      controller.root.dispatchEvent(
        new CustomEvent(isOpen ? 'bm:3dPreview:opened' : 'bm:3dPreview:closed', {
          bubbles: true,
          detail: { sectionId: controller.config.sectionId }
        })
      );
    }
    if (isOpen && shouldLoad && !controller.hasReadyModel) {
      void bm_3dPreview_load(controller);
    }
  }

  function bm_3dPreview_initOverlayBridge(controller) {
    const bm_3dPreview_closeHandler = () =>
      bm_3dPreview_setOverlayOpen(controller, false);
    const bm_3dPreview_eventHandler = (event) => {
      const bm_3dPreview_detail = event.detail || {};
      if (
        bm_3dPreview_detail.sectionId &&
        String(bm_3dPreview_detail.sectionId) !== String(controller.config.sectionId)
      ) {
        return;
      }
      bm_3dPreview_setOverlayOpen(
        controller,
        event.type === 'bm:3dPreview:open',
        bm_3dPreview_detail.load !== false
      );
    };

    controller.nodes.overlayClose?.addEventListener('click', bm_3dPreview_closeHandler);
    document.addEventListener('bm:3dPreview:open', bm_3dPreview_eventHandler);
    document.addEventListener('bm:3dPreview:close', bm_3dPreview_eventHandler);
    controller.cleanupCallbacks.push(() => {
      controller.nodes.overlayClose?.removeEventListener('click', bm_3dPreview_closeHandler);
      document.removeEventListener('bm:3dPreview:open', bm_3dPreview_eventHandler);
      document.removeEventListener('bm:3dPreview:close', bm_3dPreview_eventHandler);
    });
  }

  function bm_3dPreview_initFullscreen(controller) {
    const bm_3dPreview_button = controller.nodes.fullscreenButton;
    const bm_3dPreview_label = controller.nodes.fullscreenLabel;
    const bm_3dPreview_stage = controller.nodes.stage;
    const bm_3dPreview_requestFullscreen =
      bm_3dPreview_stage?.requestFullscreen ||
      bm_3dPreview_stage?.webkitRequestFullscreen;
    const bm_3dPreview_exitFullscreen =
      document.exitFullscreen || document.webkitExitFullscreen;
    const bm_3dPreview_fullscreenEnabled =
      document.fullscreenEnabled === true ||
      document.webkitFullscreenEnabled === true ||
      (document.fullscreenEnabled == null &&
        document.webkitFullscreenEnabled == null);

    if (
      !bm_3dPreview_button ||
      !bm_3dPreview_label ||
      typeof bm_3dPreview_requestFullscreen !== 'function' ||
      typeof bm_3dPreview_exitFullscreen !== 'function' ||
      !bm_3dPreview_fullscreenEnabled
    ) {
      return;
    }

    const bm_3dPreview_getFullscreenElement = () =>
      document.fullscreenElement || document.webkitFullscreenElement || null;
    const bm_3dPreview_syncFullscreenState = () => {
      const bm_3dPreview_isFullscreen =
        bm_3dPreview_getFullscreenElement() === bm_3dPreview_stage;
      const bm_3dPreview_buttonLabel = bm_3dPreview_isFullscreen
        ? bm_3dPreview_button.dataset.bmExitLabel
        : bm_3dPreview_button.dataset.bmEnterLabel;

      bm_3dPreview_button.setAttribute(
        'aria-pressed',
        String(bm_3dPreview_isFullscreen)
      );
      bm_3dPreview_button.setAttribute('aria-label', bm_3dPreview_buttonLabel);
      bm_3dPreview_label.textContent = bm_3dPreview_buttonLabel;
      controller.root.classList.toggle(
        'bm_3dPreview_root--fullscreen',
        bm_3dPreview_isFullscreen
      );
      window.requestAnimationFrame(() => bm_3dPreview_resize(controller));
    };
    const bm_3dPreview_fullscreenErrorHandler = () => {
      if (controller.destroyed) return;
      bm_3dPreview_button.disabled = false;
      bm_3dPreview_setStatus(
        controller,
        'Der Vollbildmodus konnte nicht geöffnet werden.',
        'warning'
      );
    };
    const bm_3dPreview_toggleFullscreen = async () => {
      if (bm_3dPreview_button.disabled || controller.destroyed) return;
      bm_3dPreview_button.disabled = true;

      try {
        if (bm_3dPreview_getFullscreenElement() === bm_3dPreview_stage) {
          await Promise.resolve(bm_3dPreview_exitFullscreen.call(document));
        } else {
          await Promise.resolve(
            bm_3dPreview_requestFullscreen.call(bm_3dPreview_stage)
          );
        }
        bm_3dPreview_syncFullscreenState();
      } catch (_bm_3dPreview_error) {
        bm_3dPreview_fullscreenErrorHandler();
      } finally {
        bm_3dPreview_button.disabled = false;
      }
    };

    bm_3dPreview_button.hidden = false;
    bm_3dPreview_button.addEventListener('click', bm_3dPreview_toggleFullscreen);
    document.addEventListener(
      'fullscreenchange',
      bm_3dPreview_syncFullscreenState
    );
    document.addEventListener(
      'webkitfullscreenchange',
      bm_3dPreview_syncFullscreenState
    );
    bm_3dPreview_stage.addEventListener(
      'fullscreenerror',
      bm_3dPreview_fullscreenErrorHandler
    );
    bm_3dPreview_stage.addEventListener(
      'webkitfullscreenerror',
      bm_3dPreview_fullscreenErrorHandler
    );
    bm_3dPreview_syncFullscreenState();

    controller.cleanupCallbacks.push(() => {
      bm_3dPreview_button.removeEventListener(
        'click',
        bm_3dPreview_toggleFullscreen
      );
      document.removeEventListener(
        'fullscreenchange',
        bm_3dPreview_syncFullscreenState
      );
      document.removeEventListener(
        'webkitfullscreenchange',
        bm_3dPreview_syncFullscreenState
      );
      bm_3dPreview_stage.removeEventListener(
        'fullscreenerror',
        bm_3dPreview_fullscreenErrorHandler
      );
      bm_3dPreview_stage.removeEventListener(
        'webkitfullscreenerror',
        bm_3dPreview_fullscreenErrorHandler
      );
      controller.root.classList.remove('bm_3dPreview_root--fullscreen');
    });
  }

  function bm_3dPreview_initSection(root) {
    if (!root || bm_3dPreview_controllers.has(root)) return;

    const bm_3dPreview_nodes = {
      stage: root.querySelector('[data-bm-role="stage"]'),
      canvasHost: root.querySelector('[data-bm-role="canvas-host"]'),
      loadButton: root.querySelector('[data-bm-role="load"]'),
      resetButton: root.querySelector('[data-bm-role="reset-camera"]'),
      fullscreenButton: root.querySelector('[data-bm-role="fullscreen-button"]'),
      fullscreenLabel: root.querySelector('[data-bm-role="fullscreen-label"]'),
      overlayClose: root.querySelector('[data-bm-role="overlay-close"]'),
      colorPicker: root.querySelector('[data-bm-role="color-picker"]'),
      colorOptions: root.querySelector('[data-bm-role="color-options"]'),
      colorInfoButton: root.querySelector('[data-bm-role="color-info-button"]'),
      colorInfoPanel: root.querySelector('[data-bm-role="color-info-panel"]'),
      cartMismatchNotice: root.querySelector(
        '[data-bm-role="cart-mismatch-notice"]'
      ),
      mapAttribution: root.querySelector('[data-bm-role="map-attribution"]'),
      osmMapAttribution: root.querySelector(
        '[data-bm-role="osm-map-attribution"]'
      ),
      satelliteMapAttribution: root.querySelector(
        '[data-bm-role="satellite-map-attribution"]'
      ),
      status: root.querySelector('[data-bm-role="status"]'),
      adminStatus: root.querySelector('[data-bm-role="admin-status"]')
    };

    if (
      !bm_3dPreview_nodes.stage ||
      !bm_3dPreview_nodes.canvasHost ||
      !bm_3dPreview_nodes.loadButton ||
      !bm_3dPreview_nodes.resetButton ||
      !bm_3dPreview_nodes.status
    ) {
      return;
    }

    const bm_3dPreview_productData = bm_3dPreview_readProductData(root);
    const bm_3dPreview_config = bm_3dPreview_readConfig(root);
    const bm_3dPreview_materialOptionNames =
      bm_3dPreview_productData?.optionNames || [];
    let bm_3dPreview_materialOptionIndex =
      bm_3dPreview_materialOptionNames.findIndex(
        (bm_3dPreview_name) =>
          bm_3dPreview_normalizedLabel(bm_3dPreview_name) ===
          bm_3dPreview_normalizedLabel(
            bm_3dPreview_config.materialOptionName
          )
      );
    if (bm_3dPreview_materialOptionIndex < 0) {
      bm_3dPreview_materialOptionIndex =
        bm_3dPreview_materialOptionNames.findIndex((bm_3dPreview_name) => {
          const bm_3dPreview_key = bm_3dPreview_normalizedLabel(
            bm_3dPreview_name
          );
          return ['rahmen', 'holz', 'frame', 'wood'].some((bm_3dPreview_term) =>
            bm_3dPreview_key.includes(bm_3dPreview_term)
          );
        });
    }
    const bm_3dPreview_colorOptionIndex =
      bm_3dPreview_productData?.optionNames?.findIndex(
        (bm_3dPreview_name) =>
          bm_3dPreview_normalizedLabel(bm_3dPreview_name) ===
          bm_3dPreview_normalizedLabel(
            bm_3dPreview_config.colorOptionName
          )
      ) ?? -1;
    const bm_3dPreview_initialGpxTrack = bm_3dPreview_cloneGpxTrack(
      window.BM.bm_peakExplorer_getGpxTrack?.(
        bm_3dPreview_config.selectionSectionId
      )
    );
    const bm_3dPreview_controller = {
      root,
      config: bm_3dPreview_config,
      nodes: bm_3dPreview_nodes,
      adminMessages: bm_3dPreview_parseAdminMessages(root),
      productData: bm_3dPreview_productData,
      productVariantIds: new Set(
        (bm_3dPreview_productData?.variants || [])
          .map((bm_3dPreview_variant) => Number(bm_3dPreview_variant?.id))
          .filter(Number.isFinite)
      ),
      materialOptionIndex: bm_3dPreview_materialOptionIndex,
      colorOptionIndex: bm_3dPreview_colorOptionIndex,
      cleanupCallbacks: [],
      vendor: null,
      sceneState: null,
      catalog: null,
      catalogUrl: '',
      currentSelection: bm_3dPreview_initialGpxTrack?.selection || null,
      currentGpxTrack: bm_3dPreview_initialGpxTrack,
      boundSelectionSectionId: String(
        bm_3dPreview_initialGpxTrack?.sectionId || ''
      ),
      gpxRenderSignature: bm_3dPreview_gpxRenderSignature(
        bm_3dPreview_initialGpxTrack
      ),
      abortController: null,
      selectionTimeoutId: null,
      colorUiTimeoutId: null,
      snowSettingsTimeoutId: null,
      snowWorker: null,
      snowMaskFailed: false,
      glacierMaskFailed: false,
      snowEnabled: bm_3dPreview_config.snowEnabled,
      snowMode: bm_3dPreview_config.snowEnabled ? 'snow' : 'off',
      snowBaseLineM: bm_3dPreview_config.snowBaseLineM,
      currentTerrainData: null,
      loadGeneration: 0,
      materialGeneration: 0,
      currentWoodKey: '',
      materials: Object.freeze([]),
      selectedColor: null,
      surfaceBaseColor: null,
      cartColor: null,
      componentMaterial: null,
      componentMaterialKey: '',
      materialWarningMessage: '',
      hasReadyModel: false,
      destroyed: false
    };

    const bm_3dPreview_loadHandler = () => bm_3dPreview_load(bm_3dPreview_controller);
    const bm_3dPreview_resetHandler = () =>
      bm_3dPreview_resetPreview(bm_3dPreview_controller);
    const bm_3dPreview_selectionHandler = (event) =>
      bm_3dPreview_handleSelectionChange(bm_3dPreview_controller, event);
    const bm_3dPreview_gpxHandler = (event) =>
      bm_3dPreview_handleGpxChange(bm_3dPreview_controller, event);

    bm_3dPreview_nodes.loadButton.addEventListener('click', bm_3dPreview_loadHandler);
    bm_3dPreview_nodes.resetButton.addEventListener('click', bm_3dPreview_resetHandler);
    document.addEventListener(BM_3D_PREVIEW_SELECTION_EVENT, bm_3dPreview_selectionHandler);
    document.addEventListener(BM_3D_PREVIEW_GPX_EVENT, bm_3dPreview_gpxHandler);

    bm_3dPreview_controller.cleanupCallbacks.push(() => {
      bm_3dPreview_nodes.loadButton.removeEventListener('click', bm_3dPreview_loadHandler);
      bm_3dPreview_nodes.resetButton.removeEventListener('click', bm_3dPreview_resetHandler);
      document.removeEventListener(
        BM_3D_PREVIEW_SELECTION_EVENT,
        bm_3dPreview_selectionHandler
      );
      document.removeEventListener(BM_3D_PREVIEW_GPX_EVENT, bm_3dPreview_gpxHandler);
    });

    bm_3dPreview_initMaterialVariantBridge(bm_3dPreview_controller);
    bm_3dPreview_initColorInfo(bm_3dPreview_controller);
    bm_3dPreview_initFullscreen(bm_3dPreview_controller);
    bm_3dPreview_initSnowSettingsBridge(bm_3dPreview_controller);
    bm_3dPreview_initOverlayBridge(bm_3dPreview_controller);
    if (bm_3dPreview_colorOptionIndex >= 0) {
      void bm_3dPreview_loadMaterials(bm_3dPreview_controller)
        .then((bm_3dPreview_materials) => {
          if (bm_3dPreview_controller.destroyed) return;
          bm_3dPreview_controller.materials = bm_3dPreview_filterAvailableMaterials(
            bm_3dPreview_controller,
            bm_3dPreview_materials
          );
          bm_3dPreview_renderColorPicker(bm_3dPreview_controller);
          bm_3dPreview_syncColorVariant(bm_3dPreview_controller);
          bm_3dPreview_initColorVariantBridge(bm_3dPreview_controller);
        })
        .catch((bm_3dPreview_error) => {
          if (bm_3dPreview_controller.destroyed) return;
          bm_3dPreview_setAdminStatus(
            bm_3dPreview_controller,
            bm_3dPreview_error?.bm_3dPreview_adminKey || 'color'
          );
        });
    } else if (bm_3dPreview_config.designMode) {
      bm_3dPreview_setAdminStatus(bm_3dPreview_controller, 'color');
    }
    bm_3dPreview_controllers.set(root, bm_3dPreview_controller);
  }

  function bm_3dPreview_cleanupSection(root) {
    const bm_3dPreview_controller = bm_3dPreview_controllers.get(root);
    if (!bm_3dPreview_controller) return;

    bm_3dPreview_controller.destroyed = true;
    bm_3dPreview_controller.loadGeneration += 1;
    bm_3dPreview_controller.materialGeneration += 1;
    bm_3dPreview_controller.abortController?.abort();
    bm_3dPreview_controller.snowWorker?.terminate?.();
    bm_3dPreview_controller.snowWorker = null;
    window.clearTimeout(bm_3dPreview_controller.selectionTimeoutId);
    window.clearTimeout(bm_3dPreview_controller.snowSettingsTimeoutId);
    bm_3dPreview_controller.currentTerrainData = null;
    bm_3dPreview_controller.currentGpxTrack = null;
    bm_3dPreview_snowStates.delete(
      String(bm_3dPreview_controller.config.sectionId)
    );

    const bm_3dPreview_sceneState = bm_3dPreview_controller.sceneState;
    if (bm_3dPreview_sceneState) {
      bm_3dPreview_sceneState.resizeObserver?.disconnect();
      bm_3dPreview_sceneState.controls.dispose();
      bm_3dPreview_disposeObject(bm_3dPreview_sceneState.currentModel);
      bm_3dPreview_sceneState.renderer.dispose();
      bm_3dPreview_sceneState.renderer.forceContextLoss?.();
    }

    bm_3dPreview_controller.cleanupCallbacks.reverse().forEach((bm_3dPreview_cleanup) => {
      bm_3dPreview_cleanup();
    });
    bm_3dPreview_controller.cleanupCallbacks.length = 0;
    bm_3dPreview_controllers.delete(root);
  }

  function bm_3dPreview_initializeServices() {
    const bm_3dPreview_createTerrainService =
      window.BM.bm_3dPreview_createTerrainService;
    const bm_3dPreview_createMapService =
      window.BM.bm_3dPreview_createMapService;
    const bm_3dPreview_createModelService =
      window.BM.bm_3dPreview_createModelService;
    const bm_3dPreview_createGpxService =
      window.BM.bm_3dPreview_createGpxService;
    if (
      typeof bm_3dPreview_createTerrainService !== 'function' ||
      typeof bm_3dPreview_createMapService !== 'function' ||
      typeof bm_3dPreview_createModelService !== 'function'
    ) {
      return false;
    }

    try {
      const bm_3dPreview_terrainService = bm_3dPreview_createTerrainService({
        BM_3D_PREVIEW_COG_BLOCK_SIZE,
        BM_3D_PREVIEW_COG_CACHE_BLOCKS,
        BM_3D_PREVIEW_KM_PER_LATITUDE_DEGREE,
        BM_3D_PREVIEW_KM_PER_LONGITUDE_DEGREE,
        BM_3D_PREVIEW_MAX_CATALOG_TILES,
        BM_3D_PREVIEW_MAX_SELECTION_TILES,
        BM_3D_PREVIEW_MIN_GRID_EDGE,
        BM_3D_PREVIEW_MIN_TERRAIN_SIDE_HEIGHT_MM,
        BM_3D_PREVIEW_TERRAIN_WIDTH,
        BM_3D_PREVIEW_TILE_CONCURRENCY,
        bm_3dPreview_cloneSelection,
        bm_3dPreview_failure,
        bm_3dPreview_httpsUrl,
        bm_3dPreview_isAbort,
        bm_3dPreview_mercatorY: (...bm_3dPreview_arguments) =>
          bm_3dPreview_mercatorY(...bm_3dPreview_arguments),
        bm_3dPreview_number,
        bm_3dPreview_sceneLengthFromMillimeters
      });
      bm_3dPreview_bilinearValue = bm_3dPreview_terrainService.bilinearValue;
      bm_3dPreview_createTerrainGeometry =
        bm_3dPreview_terrainService.createTerrainGeometry;
      bm_3dPreview_readTerrain = bm_3dPreview_terrainService.readTerrain;

      const bm_3dPreview_mapService = bm_3dPreview_createMapService({
        BM_3D_PREVIEW_KM_PER_LATITUDE_DEGREE,
        BM_3D_PREVIEW_KM_PER_LONGITUDE_DEGREE,
        BM_3D_PREVIEW_MAP_MIN_EDGE,
        BM_3D_PREVIEW_MAP_TIMEOUT_MS,
        BM_3D_PREVIEW_MEADOW_COLOR_RGB,
        BM_3D_PREVIEW_MEADOW_MAX_ELEVATION_M,
        BM_3D_PREVIEW_ROCK_COLOR_RGB,
        BM_3D_PREVIEW_SNOW_TIMEOUT_MS,
        bm_3dPreview_abortError,
        bm_3dPreview_bilinearValue,
        bm_3dPreview_color,
        bm_3dPreview_failure,
        bm_3dPreview_isAbort,
        bm_3dPreview_selectedColor,
        bm_3dPreview_selectedMapStyleUrl,
        bm_3dPreview_throwIfAborted
      });
      bm_3dPreview_createMapTexture = bm_3dPreview_mapService.createMapTexture;
      bm_3dPreview_mercatorY = bm_3dPreview_mapService.mercatorY;

      const bm_3dPreview_modelService = bm_3dPreview_createModelService({
        BM_3D_PREVIEW_BASE_GRAIN_SIZE_MM,
        BM_3D_PREVIEW_BASE_MARGIN_MM,
        BM_3D_PREVIEW_COMPONENT_TOLERANCE_MM,
        BM_3D_PREVIEW_FRAME_GRAIN_CROSS_MM,
        BM_3D_PREVIEW_FRAME_GRAIN_LENGTH_MM,
        BM_3D_PREVIEW_MIN_BASE_THICKNESS_MM,
        BM_3D_PREVIEW_PRINT_LINE_COUNT,
        BM_3D_PREVIEW_PRINT_LINE_STRENGTH,
        BM_3D_PREVIEW_SHADOW_GAP_MM,
        bm_3dPreview_abortError,
        bm_3dPreview_createMapTexture,
        bm_3dPreview_createTerrainGeometry,
        bm_3dPreview_disposeObject,
        bm_3dPreview_failure,
        bm_3dPreview_isAbort,
        bm_3dPreview_sceneLengthFromMillimeters,
        bm_3dPreview_scheduleRender,
        bm_3dPreview_selectedColor,
        bm_3dPreview_setAdminStatus,
        bm_3dPreview_setStatus,
        bm_3dPreview_throwIfAborted
      });
      bm_3dPreview_applyWoodTexture =
        bm_3dPreview_modelService.applyWoodTexture;
      bm_3dPreview_buildModel = bm_3dPreview_modelService.buildModel;

      if (typeof bm_3dPreview_createGpxService === 'function') {
        const bm_3dPreview_gpxService = bm_3dPreview_createGpxService({
          BM_3D_PREVIEW_KM_PER_LATITUDE_DEGREE,
          BM_3D_PREVIEW_KM_PER_LONGITUDE_DEGREE,
          BM_3D_PREVIEW_MIN_TERRAIN_SIDE_HEIGHT_MM,
          BM_3D_PREVIEW_TERRAIN_WIDTH,
          bm_3dPreview_bilinearValue,
          bm_3dPreview_disposeObject,
          bm_3dPreview_mercatorY: (...bm_3dPreview_arguments) =>
            bm_3dPreview_mercatorY(...bm_3dPreview_arguments),
          bm_3dPreview_sceneLengthFromMillimeters,
          bm_3dPreview_scheduleRender
        });
        bm_3dPreview_applyGpxTrack = bm_3dPreview_gpxService.apply;
      } else {
        window.console?.warn?.(
          '[bm_3dPreview_viewer] bm_3dPreview_createGpxService fehlt – ' +
            'GPX-Tracks können in der 3D-Vorschau nicht dargestellt werden. ' +
            'Bitte bm_3dPreview_gpx.js als Theme-Asset prüfen.'
        );
        bm_3dPreview_applyGpxTrack = () => false;
      }
    } catch (_bm_3dPreview_serviceError) {
      return false;
    }

    return [
      bm_3dPreview_applyWoodTexture,
      bm_3dPreview_applyGpxTrack,
      bm_3dPreview_bilinearValue,
      bm_3dPreview_buildModel,
      bm_3dPreview_createMapTexture,
      bm_3dPreview_createTerrainGeometry,
      bm_3dPreview_mercatorY,
      bm_3dPreview_readTerrain
    ].every((bm_3dPreview_serviceFunction) =>
      typeof bm_3dPreview_serviceFunction === 'function'
    );
  }

  function bm_3dPreview_getRoots(scope = document) {
    const bm_3dPreview_roots = [];
    if (scope.matches?.(BM_3D_PREVIEW_ROOT_SELECTOR)) bm_3dPreview_roots.push(scope);
    if (scope.querySelectorAll) {
      bm_3dPreview_roots.push(...scope.querySelectorAll(BM_3D_PREVIEW_ROOT_SELECTOR));
    }
    return bm_3dPreview_roots;
  }

  function bm_3dPreview_initSections(scope = document) {
    bm_3dPreview_getRoots(scope).forEach(bm_3dPreview_initSection);
  }

  function bm_3dPreview_cleanupSections(scope = document) {
    bm_3dPreview_getRoots(scope).forEach(bm_3dPreview_cleanupSection);
  }

  window.BM.bm_3dPreview_initSections = bm_3dPreview_initSections;
  window.BM.bm_3dPreview_cleanupSections = bm_3dPreview_cleanupSections;
  window.BM.bm_3dPreview_openOverlay = (sectionId = '', load = true) => {
    document.dispatchEvent(
      new CustomEvent('bm:3dPreview:open', { detail: { sectionId, load } })
    );
  };
  window.BM.bm_3dPreview_closeOverlay = (sectionId = '') => {
    document.dispatchEvent(
      new CustomEvent('bm:3dPreview:close', { detail: { sectionId } })
    );
  };
  window.BM.bm_3dPreview_setMapMode = (sectionId = '', mode = 'original') => {
    const bm_3dPreview_mode = String(mode || '').trim().toLowerCase();
    if (!['original', 'none', 'osm', 'topographic', 'satellite'].includes(bm_3dPreview_mode)) {
      return false;
    }

    const bm_3dPreview_sectionId = String(sectionId || '').trim();
    const bm_3dPreview_matchingControllers = bm_3dPreview_getRoots(document)
      .map((bm_3dPreview_root) => bm_3dPreview_controllers.get(bm_3dPreview_root))
      .filter(
        (bm_3dPreview_controller) =>
          bm_3dPreview_controller &&
          !bm_3dPreview_controller.destroyed &&
          (!bm_3dPreview_sectionId ||
            bm_3dPreview_controller.config.sectionId === bm_3dPreview_sectionId)
      );
    if (bm_3dPreview_matchingControllers.length !== 1) return false;

    const bm_3dPreview_controller = bm_3dPreview_matchingControllers[0];
    if (
      bm_3dPreview_mode === 'topographic' &&
      !bm_3dPreview_controller.config.topographicMapStyleUrl
    ) {
      return false;
    }
    if (
      bm_3dPreview_mode === 'satellite' &&
      !bm_3dPreview_controller.config.satelliteMapStyleUrl
    ) {
      return false;
    }

    if (!bm_3dPreview_controller.surfaceBaseColor) {
      bm_3dPreview_controller.surfaceBaseColor =
        bm_3dPreview_selectedColor(bm_3dPreview_controller);
    }
    const bm_3dPreview_surfaceBaseColor =
      bm_3dPreview_controller.surfaceBaseColor;
    const bm_3dPreview_surfaceColor =
      bm_3dPreview_mode === 'original'
        ? bm_3dPreview_surfaceBaseColor
        : Object.freeze({
            id: `bm_surface_${bm_3dPreview_mode}_${bm_3dPreview_surfaceBaseColor.id || 'base'}`,
            terrainColor: bm_3dPreview_surfaceBaseColor.terrainColor,
            osmFeatureColor: bm_3dPreview_surfaceBaseColor.osmFeatureColor || '',
            mapMode: bm_3dPreview_mode
          });
    bm_3dPreview_applySelectedColor(
      bm_3dPreview_controller,
      bm_3dPreview_surfaceColor
    );
    bm_3dPreview_controller.root.dispatchEvent(
      new CustomEvent('bm:3dPreview:map-mode-applied', {
        bubbles: true,
        detail: {
          sectionId: bm_3dPreview_controller.config.sectionId,
          mode: bm_3dPreview_mode
        }
      })
    );
    return true;
  };
  window.BM.bm_3dPreview_setSnowSettings = (input = {}) => {
    const bm_3dPreview_settings = bm_3dPreview_normalizeSnowSettings(input);
    if (!bm_3dPreview_settings) return false;
    const bm_3dPreview_storedSettings =
      bm_3dPreview_storeSnowOverride(bm_3dPreview_settings);
    document.dispatchEvent(
      new CustomEvent(BM_3D_PREVIEW_SNOW_SETTINGS_EVENT, {
        detail: bm_3dPreview_storedSettings
      })
    );
    return true;
  };
  window.BM.bm_3dPreview_getSnowSettings = (sectionId = '') => {
    const bm_3dPreview_key = String(sectionId || '').trim();
    let bm_3dPreview_state = bm_3dPreview_key
      ? bm_3dPreview_snowStates.get(bm_3dPreview_key) ||
        bm_3dPreview_snowOverrides.get(bm_3dPreview_key)
      : null;
    if (!bm_3dPreview_state && !bm_3dPreview_key && bm_3dPreview_snowStates.size === 1) {
      bm_3dPreview_state = bm_3dPreview_snowStates.values().next().value;
    }
    if (!bm_3dPreview_state && !bm_3dPreview_key) {
      bm_3dPreview_state = bm_3dPreview_snowOverrides.get('*');
    }
    return bm_3dPreview_state
      ? Object.freeze({ ...bm_3dPreview_state })
      : null;
  };
  window.BM.bm_3dPreview_debugGpxState = () =>
    bm_3dPreview_getRoots(document).map((bm_3dPreview_root) => {
      const bm_3dPreview_controller = bm_3dPreview_controllers.get(bm_3dPreview_root);
      if (!bm_3dPreview_controller) {
        return {
          sectionId: String(bm_3dPreview_root.dataset.bmSectionId || ''),
          initialized: false,
          visible: Boolean(bm_3dPreview_root.getClientRects?.().length)
        };
      }

      const bm_3dPreview_summary = (bm_3dPreview_selection) =>
        bm_3dPreview_selection
          ? {
              sectionId: bm_3dPreview_selection.sectionId,
              center: bm_3dPreview_selection.center,
              widthKm: bm_3dPreview_selection.widthKm,
              heightKm: bm_3dPreview_selection.heightKm,
              rotationDeg: bm_3dPreview_selection.rotationDeg,
              printWidthCm: bm_3dPreview_selection.printWidthCm,
              polygonPointCount: bm_3dPreview_selection.polygon?.length || 0
            }
          : null;

      return {
        sectionId: bm_3dPreview_controller.config.sectionId,
        initialized: true,
        visible: Boolean(bm_3dPreview_root.getClientRects?.().length),
        extentMode: bm_3dPreview_controller.config.extentMode,
        selectionSectionId: bm_3dPreview_controller.config.selectionSectionId,
        gpxModuleUrl: bm_3dPreview_controller.config.gpxModuleUrl,
        gpxServiceLoaded:
          typeof window.BM.bm_3dPreview_createGpxService === 'function',
        applyGpxTrackAvailable: typeof bm_3dPreview_applyGpxTrack === 'function',
        hasReadyModel: bm_3dPreview_controller.hasReadyModel,
        trackSegmentCount:
          bm_3dPreview_controller.currentGpxTrack?.segments?.length || 0,
        trackPointCount:
          bm_3dPreview_controller.currentGpxTrack?.pointCount || 0,
        trackSelection: bm_3dPreview_summary(
          bm_3dPreview_controller.currentGpxTrack?.selection
        ),
        currentSelection: bm_3dPreview_summary(
          bm_3dPreview_controller.currentSelection
        ),
        terrainSelection: bm_3dPreview_summary(
          bm_3dPreview_controller.currentTerrainData?.selection
        ),
        lastGpxDiagnostics: window.BM.bm_3dPreview_lastGpxDiagnostics || null
      };
    });

  document.dispatchEvent(new CustomEvent('bm:3dPreview:api-ready'));

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => bm_3dPreview_initSections(),
      { once: true }
    );
  } else {
    bm_3dPreview_initSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bm_3dPreview_initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    bm_3dPreview_cleanupSections(event.target);
  });
})();
